(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define('ProfileProctorGroups', [], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.ProfileProctorGroups = factory();
  }
}(this, function() {

  /**
   * Sets proctor groups based on an array of integer values
   * that matches the number of tests in the proctor specification
   * and is in alphabetical order with respect to proctor test names.
   *
   * If no values are supplied, sets default values for all groups.
   *
   * @param {Array.<Object>=} opt_values a list of integers that matches proctor test groups for the request.
   * @private
   * @constructor
   */
    var ProfileProctorGroups_ = function(opt_values) {
        if (opt_values) {
            if (Array.isArray(opt_values)) {
                var testDef;
                testDef = opt_values[0];
                this.eeodp_profile_tstValue_ = testDef[0];
                testDef = opt_values[1];
                this.hiredsignal_resume_autocomplete_tstValue_ = testDef[0];
                testDef = opt_values[2];
                this.ia_tailored_resume_tstValue_ = testDef[0];
                testDef = opt_values[3];
                this.ibu_india_profile_location_area_field_tstValue_ = testDef[0];
                testDef = opt_values[4];
                this.ibu_india_resume_discovery_users_tstValue_ = testDef[0];
                testDef = opt_values[5];
                this.ibu_jsc_profile_education_tstValue_ = testDef[0];
                testDef = opt_values[6];
                this.ibu_jsc_profile_phone_mandatoryValue_ = testDef[0];
                testDef = opt_values[7];
                this.ibu_jsc_profile_workexp_tstValue_ = testDef[0];
                testDef = opt_values[8];
                this.in_apply_resume_builder_educationValue_ = testDef[0];
                testDef = opt_values[9];
                this.in_apply_resume_builder_work_expValue_ = testDef[0];
                testDef = opt_values[10];
                this.in_resume_builder_certificationValue_ = testDef[0];
                testDef = opt_values[11];
                this.in_resume_builder_currentsalaryValue_ = testDef[0];
                testDef = opt_values[12];
                this.in_resume_builder_education_new_fieldsValue_ = testDef[0];
                testDef = opt_values[13];
                this.in_resume_builder_language_proficiency_pageValue_ = testDef[0];
                testDef = opt_values[14];
                this.in_resume_builder_linksValue_ = testDef[0];
                testDef = opt_values[15];
                this.in_resume_builder_work_exp_new_fieldsValue_ = testDef[0];
                testDef = opt_values[16];
                this.in_resume_upload_profile_missing_info_tstValue_ = testDef[0];
                testDef = opt_values[17];
                this.intl_non_pdf_searchability_lockValue_ = testDef[0];
                testDef = opt_values[18];
                this.iosnative_premium_profile_insightsValue_ = testDef[0];
                testDef = opt_values[19];
                this.iosnative_rich_profilesValue_ = testDef[0];
                testDef = opt_values[20];
                this.itd_india_phoneconsentremoval_tstValue_ = testDef[0];
                testDef = opt_values[21];
                this.jcs_big6_tstValue_ = testDef[0];
                testDef = opt_values[22];
                this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ = testDef[0];
                this.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_ = testDef[1];
                testDef = opt_values[23];
                this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = testDef[0];
                this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = testDef[1];
                testDef = opt_values[24];
                this.jpm_light_profile_pow_tstValue_ = testDef[0];
                testDef = opt_values[25];
                this.jpmp_jsg_pow_rag_promo_tstValue_ = testDef[0];
                this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = testDef[1];
                testDef = opt_values[26];
                this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = testDef[0];
                testDef = opt_values[27];
                this.js_pro_profile_enhancements_tstValue_ = testDef[0];
                testDef = opt_values[28];
                this.jsj_crowtaxo_holdout_tstValue_ = testDef[0];
                testDef = opt_values[29];
                this.jso_homepage_preferences_surface_factors_data_tstValue_ = testDef[0];
                testDef = opt_values[30];
                this.jso_minimal_onboarding_tstValue_ = testDef[0];
                testDef = opt_values[31];
                this.jso_resume_option_tstValue_ = testDef[0];
                testDef = opt_values[32];
                this.jso_signin_onboarding_tstValue_ = testDef[0];
                testDef = opt_values[33];
                this.jso_skipintro_tstValue_ = testDef[0];
                testDef = opt_values[34];
                this.jsu_employer_blocking_tstValue_ = testDef[0];
                testDef = opt_values[35];
                this.jsu_profile_location_component_tstValue_ = testDef[0];
                this.jsu_profile_location_component_tstPayloadValue_ = testDef[1];
                testDef = opt_values[36];
                this.mosaic_js_premium_parent_tstValue_ = testDef[0];
                testDef = opt_values[37];
                this.myindallowfileonlytoggleValue_ = testDef[0];
                testDef = opt_values[38];
                this.myindconvertsavedfiletstValue_ = testDef[0];
                this.myindconvertsavedfiletstPayloadValue_ = testDef[1];
                testDef = opt_values[39];
                this.myindresumebuildertstValue_ = testDef[0];
                testDef = opt_values[40];
                this.pcs_qualifications_disclaimerValue_ = testDef[0];
                testDef = opt_values[41];
                this.pet_cpra_donotsellsharelink_tstValue_ = testDef[0];
                testDef = opt_values[42];
                this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ = testDef[0];
                testDef = opt_values[43];
                this.pow_create_merged_profiles_tstValue_ = testDef[0];
                testDef = opt_values[44];
                this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ = testDef[0];
                testDef = opt_values[45];
                this.pow_current_salary_page_mvr_builderValue_ = testDef[0];
                testDef = opt_values[46];
                this.pow_edu_training_representation_splitValue_ = testDef[0];
                testDef = opt_values[47];
                this.pow_europe_builder_flow_tstValue_ = testDef[0];
                testDef = opt_values[48];
                this.pow_first_last_name_validationValue_ = testDef[0];
                testDef = opt_values[49];
                this.pow_hiredsignal_sourceability_toggle_tstValue_ = testDef[0];
                testDef = opt_values[50];
                this.pow_hub_privacy_tstValue_ = testDef[0];
                testDef = opt_values[51];
                this.pow_intl_fields_resume_localeValue_ = testDef[0];
                testDef = opt_values[52];
                this.pow_invalid_location_prompt_togValue_ = testDef[0];
                testDef = opt_values[53];
                this.pow_languages_field_migrationValue_ = testDef[0];
                testDef = opt_values[54];
                this.pow_multiple_resume_tstValue_ = testDef[0];
                testDef = opt_values[55];
                this.pow_phone_page_mvr_builderValue_ = testDef[0];
                testDef = opt_values[56];
                this.pow_privacy_promo_tstValue_ = testDef[0];
                testDef = opt_values[57];
                this.pow_prof_resume_privacy_tstValue_ = testDef[0];
                testDef = opt_values[58];
                this.pow_re_resume_localeValue_ = testDef[0];
                testDef = opt_values[59];
                this.pow_redesign_locale_pickerValue_ = testDef[0];
                testDef = opt_values[60];
                this.pow_reusable_pay_component_tstValue_ = testDef[0];
                testDef = opt_values[61];
                this.pow_skills_test_deprecationValue_ = testDef[0];
                testDef = opt_values[62];
                this.pow_skills_validationValue_ = testDef[0];
                testDef = opt_values[63];
                this.pow_work_area_preferences_frontend_tstValue_ = testDef[0];
                testDef = opt_values[64];
                this.pow_years_of_experience_resume_builder_inValue_ = testDef[0];
                testDef = opt_values[65];
                this.powfrommilitaryparametertoggleValue_ = testDef[0];
                testDef = opt_values[66];
                this.powiplphoneinputtstValue_ = testDef[0];
                testDef = opt_values[67];
                this.powreviewcompanieslinktoggleValue_ = testDef[0];
                testDef = opt_values[68];
                this.pref_location_resume_builder_inValue_ = testDef[0];
                testDef = opt_values[69];
                this.prof_auto_resume_sections_schema_tstValue_ = testDef[0];
                testDef = opt_values[70];
                this.prof_back_button_label_toggleValue_ = testDef[0];
                testDef = opt_values[71];
                this.prof_data_merge_no_resume_tstValue_ = testDef[0];
                testDef = opt_values[72];
                this.prof_data_merge_parsed_resume_tstValue_ = testDef[0];
                testDef = opt_values[73];
                this.prof_fe_merge_second_phaseValue_ = testDef[0];
                testDef = opt_values[74];
                this.prof_jp_no_thumbnailValue_ = testDef[0];
                testDef = opt_values[75];
                this.prof_mvp_data_merge_crowtaxo_togValue_ = testDef[0];
                this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = testDef[1];
                testDef = opt_values[76];
                this.prof_pdf_confirmationValue_ = testDef[0];
                testDef = opt_values[77];
                this.prof_remove_convert_to_indeed_resume_optionValue_ = testDef[0];
                testDef = opt_values[78];
                this.prof_sg_work_auth_for_parsed_rez_tstValue_ = testDef[0];
                testDef = opt_values[79];
                this.prof_skillset_toggleValue_ = testDef[0];
                testDef = opt_values[80];
                this.prof_tabbed_expValue_ = testDef[0];
                testDef = opt_values[81];
                this.prof_tabbed_exp_resume_data_importValue_ = testDef[0];
                testDef = opt_values[82];
                this.prof_tabbed_exp_resume_import_phaseValue_ = testDef[0];
                testDef = opt_values[83];
                this.prof_tabbed_exp_smiley_surveyValue_ = testDef[0];
                testDef = opt_values[84];
                this.prof_upload_file_redaction_tstValue_ = testDef[0];
                testDef = opt_values[85];
                this.profauto_ci_resume_builder_tstValue_ = testDef[0];
                this.profauto_ci_resume_builder_tstPayloadValue_ = testDef[1];
                testDef = opt_values[86];
                this.profauto_doc_to_pdf_conversion_tstValue_ = testDef[0];
                testDef = opt_values[87];
                this.profauto_minimum_pay_resume_builder_tstValue_ = testDef[0];
                testDef = opt_values[88];
                this.profile_add_segmentation_preference_togValue_ = testDef[0];
                testDef = opt_values[89];
                this.profile_ai_summary_tstValue_ = testDef[0];
                testDef = opt_values[90];
                this.profile_ai_work_description_tstValue_ = testDef[0];
                testDef = opt_values[91];
                this.profile_extracted_qualifications_tstValue_ = testDef[0];
                testDef = opt_values[92];
                this.profile_one_datadog_rum_toggleValue_ = testDef[0];
                testDef = opt_values[93];
                this.profile_one_fullstory_tstValue_ = testDef[0];
                testDef = opt_values[94];
                this.profile_one_redesign_preferences_tstValue_ = testDef[0];
                testDef = opt_values[95];
                this.profile_phone_simplificationValue_ = testDef[0];
                testDef = opt_values[96];
                this.profile_photos_togValue_ = testDef[0];
                testDef = opt_values[97];
                this.profile_text_experience_input_tstValue_ = testDef[0];
                testDef = opt_values[98];
                this.profile_title_match_autocomplete_dataset_tstValue_ = testDef[0];
                this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = testDef[1];
                testDef = opt_values[99];
                this.profile_update_app_banner_togValue_ = testDef[0];
                testDef = opt_values[100];
                this.profile_yoe_removal_togValue_ = testDef[0];
                testDef = opt_values[101];
                this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ = testDef[0];
                testDef = opt_values[102];
                this.rdp_pdf_resume_faceliftValue_ = testDef[0];
                testDef = opt_values[103];
                this.re_upload_to_replaceValue_ = testDef[0];
                testDef = opt_values[104];
                this.segment_selection_india_tstValue_ = testDef[0];
                testDef = opt_values[105];
                this.si_profile_education_description_initially_hidden_tstValue_ = testDef[0];
                testDef = opt_values[106];
                this.suggestions_ui_update_flowsValue_ = testDef[0];
                testDef = opt_values[107];
                this.title_match_autocomplete_logging_togValue_ = testDef[0];
            } else {
                var testDef;
                testDef = opt_values["c93e7e9a928e7d2b694e14c767294d610a6fcd60c05b68011f2b087ae9f4a14c"];
                if (!testDef) {
                    this.jsj_crowtaxo_holdout_tstValue_ = -1;
                } else {
                    this.jsj_crowtaxo_holdout_tstValue_ = testDef[0];
                }
                testDef = opt_values["999c9a2b536d1894466f88a9a64ad260b5da9ba363e85d9471f206e3d86438c3"];
                if (!testDef) {
                    this.jcs_big6_tstValue_ = -1;
                } else {
                    this.jcs_big6_tstValue_ = testDef[0];
                }
                testDef = opt_values["318a42bb4242c006d9b3eaabbfd52a680b2019d06f1e3874ebb718d7fcc614f8"];
                if (!testDef) {
                    this.profauto_ci_resume_builder_tstValue_ = -1;
                    this.profauto_ci_resume_builder_tstPayloadValue_ = {};
                } else {
                    this.profauto_ci_resume_builder_tstValue_ = testDef[0];
                    this.profauto_ci_resume_builder_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["78b8f07b14720acd9e5bc90bf11f9da94860090a57c8bc65571f90f1d958e12b"];
                if (!testDef) {
                    this.jpmp_jsg_pow_rag_promo_tstValue_ = -1;
                    this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = {};
                } else {
                    this.jpmp_jsg_pow_rag_promo_tstValue_ = testDef[0];
                    this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["5b696af89ccdf05ee43a6fd923dec2535f91b063a60b580e6f8b599767cc1cca"];
                if (!testDef) {
                    this.pow_current_salary_page_mvr_builderValue_ = -1;
                } else {
                    this.pow_current_salary_page_mvr_builderValue_ = testDef[0];
                }
                testDef = opt_values["80cc05edf4cb2607f3ea9aa2039780d5fa99d6a25748dd0b18e0ee8c60982331"];
                if (!testDef) {
                    this.in_resume_builder_certificationValue_ = -1;
                } else {
                    this.in_resume_builder_certificationValue_ = testDef[0];
                }
                testDef = opt_values["321039c359bcd8d11a9206e305e1c6208bf1236eb95f74938ff1eb45af82c76c"];
                if (!testDef) {
                    this.in_apply_resume_builder_educationValue_ = -1;
                } else {
                    this.in_apply_resume_builder_educationValue_ = testDef[0];
                }
                testDef = opt_values["61090043438f9a82e2cee6b3fb4a964b0e4a20a4858f5aa31b40872d18cf38b2"];
                if (!testDef) {
                    this.mosaic_js_premium_parent_tstValue_ = -1;
                } else {
                    this.mosaic_js_premium_parent_tstValue_ = testDef[0];
                }
                testDef = opt_values["61104a57002c0978162e6229bb5b6e8510b8649b7687263648d464020ae142f5"];
                if (!testDef) {
                    this.jso_skipintro_tstValue_ = -1;
                } else {
                    this.jso_skipintro_tstValue_ = testDef[0];
                }
                testDef = opt_values["966d949e62627abec586891e56be28964018796ad0ef739d712ad2a37fe380ce"];
                if (!testDef) {
                    this.in_resume_builder_linksValue_ = -1;
                } else {
                    this.in_resume_builder_linksValue_ = testDef[0];
                }
                testDef = opt_values["9347a308297cccb7a88a148d1c298525cc0f856605598a960bb7a3be5082f7dc"];
                if (!testDef) {
                    this.jso_minimal_onboarding_tstValue_ = -1;
                } else {
                    this.jso_minimal_onboarding_tstValue_ = testDef[0];
                }
                testDef = opt_values["6cf0728ab99874b2707350694eb17c5648288f467ee2509114cb4ba2e0cdda12"];
                if (!testDef) {
                    this.pow_skills_test_deprecationValue_ = -1;
                } else {
                    this.pow_skills_test_deprecationValue_ = testDef[0];
                }
                testDef = opt_values["f3dbdc58221648f0809205c969ef1be10c4e6ebe2a2f3ef4593c128c8b14489d"];
                if (!testDef) {
                    this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ = -1;
                    this.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_ = {};
                } else {
                    this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ = testDef[0];
                    this.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["a1ea75ef03346991183367f246f9476eaf5fa9a329e527c2a45121c607ec5848"];
                if (!testDef) {
                    this.jso_signin_onboarding_tstValue_ = -1;
                } else {
                    this.jso_signin_onboarding_tstValue_ = testDef[0];
                }
                testDef = opt_values["ef2cf9ae830f32d8dfe0ba13aa7fdc1539b0c3b2668bfa7b86a35eae7cebd272"];
                if (!testDef) {
                    this.myindresumebuildertstValue_ = -1;
                } else {
                    this.myindresumebuildertstValue_ = testDef[0];
                }
                testDef = opt_values["e257beb354906923eb561e6235b26777dcb3db513186721d51c0864a38965b1a"];
                if (!testDef) {
                    this.prof_pdf_confirmationValue_ = -1;
                } else {
                    this.prof_pdf_confirmationValue_ = testDef[0];
                }
                testDef = opt_values["4800448cd65e0fe212413ac99f6e09cdc713ab0655138c534496d7b6e2adc393"];
                if (!testDef) {
                    this.pow_europe_builder_flow_tstValue_ = -1;
                } else {
                    this.pow_europe_builder_flow_tstValue_ = testDef[0];
                }
                testDef = opt_values["ee6596b530d277b03e27e7559260cc1343816da944130d4c770d5e5929dddd1a"];
                if (!testDef) {
                    this.iosnative_premium_profile_insightsValue_ = -1;
                } else {
                    this.iosnative_premium_profile_insightsValue_ = testDef[0];
                }
                testDef = opt_values["d996452747c772c75c99a7ab118a327a7ca30c31577585f2fe6b2a1b7fdb8490"];
                if (!testDef) {
                    this.myindconvertsavedfiletstValue_ = -1;
                    this.myindconvertsavedfiletstPayloadValue_ = {};
                } else {
                    this.myindconvertsavedfiletstValue_ = testDef[0];
                    this.myindconvertsavedfiletstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["c625504c8ddce42e43e3bc7a0561700181a5b6c8d6f2f0dd467d9ebc6d3b32f7"];
                if (!testDef) {
                    this.profile_ai_summary_tstValue_ = -1;
                } else {
                    this.profile_ai_summary_tstValue_ = testDef[0];
                }
                testDef = opt_values["885e2df411bddc66924488bf89a4e1aa609706b634c501a14ef589b545125c8e"];
                if (!testDef) {
                    this.jso_resume_option_tstValue_ = -1;
                } else {
                    this.jso_resume_option_tstValue_ = testDef[0];
                }
                testDef = opt_values["d4e29f20fb58eeb1103227c5ff0423affa6a35cf82f2dc019b37450801026f3a"];
                if (!testDef) {
                    this.ibu_jsc_profile_phone_mandatoryValue_ = -1;
                } else {
                    this.ibu_jsc_profile_phone_mandatoryValue_ = testDef[0];
                }
                testDef = opt_values["0e3d1b925356a8c3eef21a9770458105462b8b31beb9d9d093460956ca2abde8"];
                if (!testDef) {
                    this.in_resume_builder_currentsalaryValue_ = -1;
                } else {
                    this.in_resume_builder_currentsalaryValue_ = testDef[0];
                }
                testDef = opt_values["c7dd14a7872d349ef8c65808a0d6d5159a4b8c2df01dc04ebae886347b0f3326"];
                if (!testDef) {
                    this.in_apply_resume_builder_work_expValue_ = -1;
                } else {
                    this.in_apply_resume_builder_work_expValue_ = testDef[0];
                }
                testDef = opt_values["eb549a2ff4d1eab7ed0beed3a17aac06c8bf22ede238d07073fb9d104b342687"];
                if (!testDef) {
                    this.profile_one_redesign_preferences_tstValue_ = -1;
                } else {
                    this.profile_one_redesign_preferences_tstValue_ = testDef[0];
                }
                testDef = opt_values["50a3085b73cf9e584034ac24f563c489db15e9d227e69d22db27bf075db55261"];
                if (!testDef) {
                    this.profile_text_experience_input_tstValue_ = -1;
                } else {
                    this.profile_text_experience_input_tstValue_ = testDef[0];
                }
                testDef = opt_values["5054184b380d66ef1a9da14eb35f6ed093f3aab9bfcd1d07bee83ea0a857be8e"];
                if (!testDef) {
                    this.pow_years_of_experience_resume_builder_inValue_ = -1;
                } else {
                    this.pow_years_of_experience_resume_builder_inValue_ = testDef[0];
                }
                testDef = opt_values["a1af7ca1215e787de1d7daa1da8b1f04b7aeeb191e4605645ac8aa727091b643"];
                if (!testDef) {
                    this.ibu_jsc_profile_education_tstValue_ = -1;
                } else {
                    this.ibu_jsc_profile_education_tstValue_ = testDef[0];
                }
                testDef = opt_values["2d1c84242b61780cb5c6e1288e3e7306162831a7b387cf9dc27e489af4aedd2b"];
                if (!testDef) {
                    this.si_profile_education_description_initially_hidden_tstValue_ = -1;
                } else {
                    this.si_profile_education_description_initially_hidden_tstValue_ = testDef[0];
                }
                testDef = opt_values["addcb71e6422f6e14c412ca51c44bc3399cdd7d5146c6c5b8eb4e8d7a4486872"];
                if (!testDef) {
                    this.prof_auto_resume_sections_schema_tstValue_ = -1;
                } else {
                    this.prof_auto_resume_sections_schema_tstValue_ = testDef[0];
                }
                testDef = opt_values["8d66f0e33a616af8176e89e2d9c5a8748d1cfa0da7f440ccaf9afb49e8f52235"];
                if (!testDef) {
                    this.pow_redesign_locale_pickerValue_ = -1;
                } else {
                    this.pow_redesign_locale_pickerValue_ = testDef[0];
                }
                testDef = opt_values["82cd2debeb731c53603c847d89ae10fe17bb473dcbd5f5f23719fd0ff66fe27f"];
                if (!testDef) {
                    this.pcs_qualifications_disclaimerValue_ = -1;
                } else {
                    this.pcs_qualifications_disclaimerValue_ = testDef[0];
                }
                testDef = opt_values["9b9fcc943fb2ef52e14a311f79ff18425ebacab80744852b2f902db58a9daa2f"];
                if (!testDef) {
                    this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ = -1;
                } else {
                    this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ = testDef[0];
                }
                testDef = opt_values["94036da13ad2f87b6489e78ba595e40092a377c5c14db743e03186a151166b18"];
                if (!testDef) {
                    this.pow_multiple_resume_tstValue_ = -1;
                } else {
                    this.pow_multiple_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["a90610425144f940f9f6e129e69795691ed71125106b9ccd9f11802e7aa13376"];
                if (!testDef) {
                    this.prof_tabbed_expValue_ = -1;
                } else {
                    this.prof_tabbed_expValue_ = testDef[0];
                }
                testDef = opt_values["ca6b8f0a46d3e592c8e12602f6115bacf704e1cdf5c429da41a4003249723937"];
                if (!testDef) {
                    this.in_resume_upload_profile_missing_info_tstValue_ = -1;
                } else {
                    this.in_resume_upload_profile_missing_info_tstValue_ = testDef[0];
                }
                testDef = opt_values["2cd6b57798b91fa3e93a296f769de79ce37ccf74731ffe08f9fc443bbb20874f"];
                if (!testDef) {
                    this.pow_edu_training_representation_splitValue_ = -1;
                } else {
                    this.pow_edu_training_representation_splitValue_ = testDef[0];
                }
                testDef = opt_values["a2dc970539f6637f74d9f225980794cc48123b5248c25ba1f2d1afa7ed4ece03"];
                if (!testDef) {
                    this.pow_work_area_preferences_frontend_tstValue_ = -1;
                } else {
                    this.pow_work_area_preferences_frontend_tstValue_ = testDef[0];
                }
                testDef = opt_values["433eb615cce00e8f80a5291a9240b3d509c1ee058c174d965d74eadc1d8e5f6b"];
                if (!testDef) {
                    this.in_resume_builder_language_proficiency_pageValue_ = -1;
                } else {
                    this.in_resume_builder_language_proficiency_pageValue_ = testDef[0];
                }
                testDef = opt_values["de42ca5f044174ced7bf68d349f5ed1cd7ed97970cff4833b0f19642766baf60"];
                if (!testDef) {
                    this.prof_upload_file_redaction_tstValue_ = -1;
                } else {
                    this.prof_upload_file_redaction_tstValue_ = testDef[0];
                }
                testDef = opt_values["50a7535a706bfb01b695b27306c733c3cde9b9531ea3e8cbbb443ddd125752ba"];
                if (!testDef) {
                    this.intl_non_pdf_searchability_lockValue_ = -1;
                } else {
                    this.intl_non_pdf_searchability_lockValue_ = testDef[0];
                }
                testDef = opt_values["ed1737cea9990b1ab3636eb81132e8309e30c3f965bd7ef58ec806cd52cc4b6a"];
                if (!testDef) {
                    this.prof_skillset_toggleValue_ = -1;
                } else {
                    this.prof_skillset_toggleValue_ = testDef[0];
                }
                testDef = opt_values["d8524b544dca190e1ccc8ce9922c996f70f55018ddd54fd0ce91da3806e5849b"];
                if (!testDef) {
                    this.prof_jp_no_thumbnailValue_ = -1;
                } else {
                    this.prof_jp_no_thumbnailValue_ = testDef[0];
                }
                testDef = opt_values["d6189977e40053cf39838cfb3180e881a94318eada23438032eff1ba15998021"];
                if (!testDef) {
                    this.myindallowfileonlytoggleValue_ = -1;
                } else {
                    this.myindallowfileonlytoggleValue_ = testDef[0];
                }
                testDef = opt_values["8e390b31e7f64bd603052f66afd73b2cf57f5145b51a5b975e1824cfc2f41196"];
                if (!testDef) {
                    this.pow_prof_resume_privacy_tstValue_ = -1;
                } else {
                    this.pow_prof_resume_privacy_tstValue_ = testDef[0];
                }
                testDef = opt_values["89b08817d64ca181799deb14bc863144fb04e46b3884ea24506c2d83b3561739"];
                if (!testDef) {
                    this.eeodp_profile_tstValue_ = -1;
                } else {
                    this.eeodp_profile_tstValue_ = testDef[0];
                }
                testDef = opt_values["dd301f9c1a9d7bbbae39df52d2aeeb2bf03e5bbb6ed6a51c11a5fec06a5eff57"];
                if (!testDef) {
                    this.profauto_doc_to_pdf_conversion_tstValue_ = -1;
                } else {
                    this.profauto_doc_to_pdf_conversion_tstValue_ = testDef[0];
                }
                testDef = opt_values["b19b9eb3cef83013d7b514728150e1e78f763fa86c2e593861421ac75caba5ee"];
                if (!testDef) {
                    this.pow_hub_privacy_tstValue_ = -1;
                } else {
                    this.pow_hub_privacy_tstValue_ = testDef[0];
                }
                testDef = opt_values["a3e7bae179a59b55f2314a6f0e2f37a48b281c7685fa0284cb2e8e4514daf2cb"];
                if (!testDef) {
                    this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ = -1;
                } else {
                    this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ = testDef[0];
                }
                testDef = opt_values["e42bcae6e45c57c93b7d7cc57d3624da9d557e3c7e9fc7b98130083b62551a06"];
                if (!testDef) {
                    this.profile_phone_simplificationValue_ = -1;
                } else {
                    this.profile_phone_simplificationValue_ = testDef[0];
                }
                testDef = opt_values["b68c5a30bd730bf2f24c0ef68828eac410b7392c2374f4a6e3cf1a9ba9c0725c"];
                if (!testDef) {
                    this.re_upload_to_replaceValue_ = -1;
                } else {
                    this.re_upload_to_replaceValue_ = testDef[0];
                }
                testDef = opt_values["b7ab07f9747a0d43be1b9edcc0f717fd1b28d88fa2809e4e08ad8b223cdfe0ef"];
                if (!testDef) {
                    this.pow_intl_fields_resume_localeValue_ = -1;
                } else {
                    this.pow_intl_fields_resume_localeValue_ = testDef[0];
                }
                testDef = opt_values["c1d20ab5853e06edddd3d0eb356aec05265a63896a6d8b0139ff4c4409003b1d"];
                if (!testDef) {
                    this.profile_one_datadog_rum_toggleValue_ = -1;
                } else {
                    this.profile_one_datadog_rum_toggleValue_ = testDef[0];
                }
                testDef = opt_values["1ff8e74c66c16622c26105f463865c70a6716922172fd80e65430bbfab70d3df"];
                if (!testDef) {
                    this.pow_skills_validationValue_ = -1;
                } else {
                    this.pow_skills_validationValue_ = testDef[0];
                }
                testDef = opt_values["ec1fa57a5a91c95ece610035f11b16863fc69a1b4f2ccb6c8472701f9203c519"];
                if (!testDef) {
                    this.jpm_light_profile_pow_tstValue_ = -1;
                } else {
                    this.jpm_light_profile_pow_tstValue_ = testDef[0];
                }
                testDef = opt_values["3b6ea3befac4fd788fd11a54067aaf85e9c2057ac49d4529394bd1554147927a"];
                if (!testDef) {
                    this.pow_hiredsignal_sourceability_toggle_tstValue_ = -1;
                } else {
                    this.pow_hiredsignal_sourceability_toggle_tstValue_ = testDef[0];
                }
                testDef = opt_values["7cdbdf0e9495d7204573a69a90a1e9336ae4d00888a5051a3fa7231360dae16c"];
                if (!testDef) {
                    this.in_resume_builder_work_exp_new_fieldsValue_ = -1;
                } else {
                    this.in_resume_builder_work_exp_new_fieldsValue_ = testDef[0];
                }
                testDef = opt_values["c49ab16dbb1541ff761feb7c1876510886d365772fb7c909dbf82050ed0e3cd4"];
                if (!testDef) {
                    this.pet_cpra_donotsellsharelink_tstValue_ = -1;
                } else {
                    this.pet_cpra_donotsellsharelink_tstValue_ = testDef[0];
                }
                testDef = opt_values["dda635bb67ccd95426db42d6c989e1c647c5b21c97a79220bb6f91912113ee94"];
                if (!testDef) {
                    this.prof_tabbed_exp_smiley_surveyValue_ = -1;
                } else {
                    this.prof_tabbed_exp_smiley_surveyValue_ = testDef[0];
                }
                testDef = opt_values["bdf467b4a6de4b2e232704392efaf69d9a8c0b312b098f193ed3067488503f72"];
                if (!testDef) {
                    this.rdp_pdf_resume_faceliftValue_ = -1;
                } else {
                    this.rdp_pdf_resume_faceliftValue_ = testDef[0];
                }
                testDef = opt_values["9eccbdcc8372c89e8bef7347ac1f1500d093f56c507f7a7aaa959123f7443ad7"];
                if (!testDef) {
                    this.segment_selection_india_tstValue_ = -1;
                } else {
                    this.segment_selection_india_tstValue_ = testDef[0];
                }
                testDef = opt_values["b812a6e632bf2127e95a6b87043cdecb79877e267c70f812edf0bd6022fd3f33"];
                if (!testDef) {
                    this.pow_first_last_name_validationValue_ = -1;
                } else {
                    this.pow_first_last_name_validationValue_ = testDef[0];
                }
                testDef = opt_values["398dad6ac7a10b741e963de9d04ea60a166c555e6a11d63754534f3b846a03b0"];
                if (!testDef) {
                    this.prof_mvp_data_merge_crowtaxo_togValue_ = -1;
                    this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = {};
                } else {
                    this.prof_mvp_data_merge_crowtaxo_togValue_ = testDef[0];
                    this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = testDef[1];
                }
                testDef = opt_values["bdb1703f87e9145cd1e1864be130a1dafd259a1c227d7d2a826345d86aa76462"];
                if (!testDef) {
                    this.profile_add_segmentation_preference_togValue_ = -1;
                } else {
                    this.profile_add_segmentation_preference_togValue_ = testDef[0];
                }
                testDef = opt_values["7861c8b42c6f4b7e6315a785e34cbc6971a71192504c02e38a3fcec9f96e9f81"];
                if (!testDef) {
                    this.powfrommilitaryparametertoggleValue_ = -1;
                } else {
                    this.powfrommilitaryparametertoggleValue_ = testDef[0];
                }
                testDef = opt_values["45a1d47cf2408fc0966e19fe076ca31b6f050bda3951c4f45734f4361077bd35"];
                if (!testDef) {
                    this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ = -1;
                } else {
                    this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ = testDef[0];
                }
                testDef = opt_values["5ca2ab176d7fe6ca7417c52ee48730c19bd3aaf7bd68204150ef06c931044308"];
                if (!testDef) {
                    this.pow_privacy_promo_tstValue_ = -1;
                } else {
                    this.pow_privacy_promo_tstValue_ = testDef[0];
                }
                testDef = opt_values["c84d4f5fa9ca05b56c0ece20b5cec21ffbd241ca9893781e757085e3a9a6caa5"];
                if (!testDef) {
                    this.profile_one_fullstory_tstValue_ = -1;
                } else {
                    this.profile_one_fullstory_tstValue_ = testDef[0];
                }
                testDef = opt_values["53be4f6d7c5870bf79799a5824fcbb5f464d6986ad558cb8e27872ade8e02583"];
                if (!testDef) {
                    this.profile_yoe_removal_togValue_ = -1;
                } else {
                    this.profile_yoe_removal_togValue_ = testDef[0];
                }
                testDef = opt_values["9e267d04e2ef452fd4fff347a0713432d199f43b9679977125d9a962c6f0a6e6"];
                if (!testDef) {
                    this.powreviewcompanieslinktoggleValue_ = -1;
                } else {
                    this.powreviewcompanieslinktoggleValue_ = testDef[0];
                }
                testDef = opt_values["9c7a7a92a9feedcb2244d518ce328dc994083ac6c219826f17a7fafa74adf37f"];
                if (!testDef) {
                    this.pow_invalid_location_prompt_togValue_ = -1;
                } else {
                    this.pow_invalid_location_prompt_togValue_ = testDef[0];
                }
                testDef = opt_values["226d6062d50de1ae523dae0e151831c91715899e96990282c87c4f05577bd824"];
                if (!testDef) {
                    this.pow_reusable_pay_component_tstValue_ = -1;
                } else {
                    this.pow_reusable_pay_component_tstValue_ = testDef[0];
                }
                testDef = opt_values["9ddf7970c46a5ba343057f6f9ce257570cde550ef61e0e91e69e1f7496362c84"];
                if (!testDef) {
                    this.ibu_jsc_profile_workexp_tstValue_ = -1;
                } else {
                    this.ibu_jsc_profile_workexp_tstValue_ = testDef[0];
                }
                testDef = opt_values["59bc93d4615d5d2b8c8d3ce6aeb0aac7a5515448800b3f4dc9875d2796b485fb"];
                if (!testDef) {
                    this.hiredsignal_resume_autocomplete_tstValue_ = -1;
                } else {
                    this.hiredsignal_resume_autocomplete_tstValue_ = testDef[0];
                }
                testDef = opt_values["589c5cc0a18fd46d97acf537721c9f8f6efe15d5eb32346d26cea5e5a3bfaf9a"];
                if (!testDef) {
                    this.profile_ai_work_description_tstValue_ = -1;
                } else {
                    this.profile_ai_work_description_tstValue_ = testDef[0];
                }
                testDef = opt_values["f256dd3d228316004532949cd0e6cda140ff8ca5851b30e7c00b44980392e20d"];
                if (!testDef) {
                    this.ibu_india_profile_location_area_field_tstValue_ = -1;
                } else {
                    this.ibu_india_profile_location_area_field_tstValue_ = testDef[0];
                }
                testDef = opt_values["6a16f84bbe6c96cfec47658cc44f7054d74d0899fe3d08fa835e37b95e5709f2"];
                if (!testDef) {
                    this.jsu_employer_blocking_tstValue_ = -1;
                } else {
                    this.jsu_employer_blocking_tstValue_ = testDef[0];
                }
                testDef = opt_values["6cdba8b648fe3b0be287ea8446a75a416654070d04cdcd444479bc409b7b999f"];
                if (!testDef) {
                    this.pow_re_resume_localeValue_ = -1;
                } else {
                    this.pow_re_resume_localeValue_ = testDef[0];
                }
                testDef = opt_values["ffe375f72d50c43f335b6edc31efd40f618ff214c967cf914f33810cc5892cee"];
                if (!testDef) {
                    this.pow_phone_page_mvr_builderValue_ = -1;
                } else {
                    this.pow_phone_page_mvr_builderValue_ = testDef[0];
                }
                testDef = opt_values["1feb2a001e1c6032fb2b3a095d4213a2542a628b11e962845d0297406ece9547"];
                if (!testDef) {
                    this.ibu_india_resume_discovery_users_tstValue_ = -1;
                } else {
                    this.ibu_india_resume_discovery_users_tstValue_ = testDef[0];
                }
                testDef = opt_values["9321f4d47c321c5ef8a05470a3d55f42f8f395d2a5edc92fdfc7ab3cfd84b1e4"];
                if (!testDef) {
                    this.prof_tabbed_exp_resume_data_importValue_ = -1;
                } else {
                    this.prof_tabbed_exp_resume_data_importValue_ = testDef[0];
                }
                testDef = opt_values["9cdd4efad26780ac4b79ab68750a68452ee6041a363754e95d4ed813d6716da4"];
                if (!testDef) {
                    this.js_pro_profile_enhancements_tstValue_ = -1;
                } else {
                    this.js_pro_profile_enhancements_tstValue_ = testDef[0];
                }
                testDef = opt_values["90c888c7098f853a13a74563f5488d3d09dc3c94700a0fa4a8b4714c0da60c77"];
                if (!testDef) {
                    this.profauto_minimum_pay_resume_builder_tstValue_ = -1;
                } else {
                    this.profauto_minimum_pay_resume_builder_tstValue_ = testDef[0];
                }
                testDef = opt_values["08d71e30809e55795db09e6b9c5e4d0afca031fe0f47329703bc46a595569f37"];
                if (!testDef) {
                    this.suggestions_ui_update_flowsValue_ = -1;
                } else {
                    this.suggestions_ui_update_flowsValue_ = testDef[0];
                }
                testDef = opt_values["ddbc7173f0bc4a31e771dbc4a567ad35316c7ee1b845636efd4f6b035ab4daf8"];
                if (!testDef) {
                    this.pow_create_merged_profiles_tstValue_ = -1;
                } else {
                    this.pow_create_merged_profiles_tstValue_ = testDef[0];
                }
                testDef = opt_values["cf16c6e37802b1dd9d32098f2bfb70516f19ea3174052d790582079caf256da5"];
                if (!testDef) {
                    this.title_match_autocomplete_logging_togValue_ = -1;
                } else {
                    this.title_match_autocomplete_logging_togValue_ = testDef[0];
                }
                testDef = opt_values["6d1c625071c3c9989e885798badc76a9c5704bfefc95a0e83161b7a57504ff22"];
                if (!testDef) {
                    this.prof_sg_work_auth_for_parsed_rez_tstValue_ = -1;
                } else {
                    this.prof_sg_work_auth_for_parsed_rez_tstValue_ = testDef[0];
                }
                testDef = opt_values["4e3ac3bce367e0ca3c3df934672b1430912b1ffffb45d2aa1113e68255c2b397"];
                if (!testDef) {
                    this.itd_india_phoneconsentremoval_tstValue_ = -1;
                } else {
                    this.itd_india_phoneconsentremoval_tstValue_ = testDef[0];
                }
                testDef = opt_values["ce49087491454bcad8869df4b80b1339d1b3224674041ae1ac7130eb6ac6d7e3"];
                if (!testDef) {
                    this.profile_extracted_qualifications_tstValue_ = -1;
                } else {
                    this.profile_extracted_qualifications_tstValue_ = testDef[0];
                }
                testDef = opt_values["58e46206cefff0ad0345b026a6702e4d7c13e3ad11e68a9572074d4e27525d08"];
                if (!testDef) {
                    this.prof_data_merge_parsed_resume_tstValue_ = -1;
                } else {
                    this.prof_data_merge_parsed_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["901106aa44849192bc5e07504ae513e4deb6df63c98ffbd2ded013831a36e3c8"];
                if (!testDef) {
                    this.prof_back_button_label_toggleValue_ = -1;
                } else {
                    this.prof_back_button_label_toggleValue_ = testDef[0];
                }
                testDef = opt_values["858b11683dab412e9015dbcce05e087aa7c961e3bcd32d4e8248c868f74225a8"];
                if (!testDef) {
                    this.profile_title_match_autocomplete_dataset_tstValue_ = -1;
                    this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = {};
                } else {
                    this.profile_title_match_autocomplete_dataset_tstValue_ = testDef[0];
                    this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["2476c22739bd842fa07ba52916b6e767e0fc7e5517c2b4770fc2576518e3187f"];
                if (!testDef) {
                    this.prof_tabbed_exp_resume_import_phaseValue_ = -1;
                } else {
                    this.prof_tabbed_exp_resume_import_phaseValue_ = testDef[0];
                }
                testDef = opt_values["227f4b4b3966e0ac518b882b3badbc93484b863e58cf9fa7ab43020d1fda60df"];
                if (!testDef) {
                    this.ia_tailored_resume_tstValue_ = -1;
                } else {
                    this.ia_tailored_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["9316be7f4bc61683d4fd21e2864f4ad52e9f8564e29aaeab750f292a8ae8227d"];
                if (!testDef) {
                    this.pow_languages_field_migrationValue_ = -1;
                } else {
                    this.pow_languages_field_migrationValue_ = testDef[0];
                }
                testDef = opt_values["8884be3462d97e4e6faf1c3c8e17cde152a3b0c5d818c73462de503954cd4dfc"];
                if (!testDef) {
                    this.powiplphoneinputtstValue_ = -1;
                } else {
                    this.powiplphoneinputtstValue_ = testDef[0];
                }
                testDef = opt_values["fa9779bff1215de965e0d33a5779ad1c427763c6d28fc8245c7a99234a3f6f13"];
                if (!testDef) {
                    this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = -1;
                } else {
                    this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = testDef[0];
                }
                testDef = opt_values["26636867e49724d20b230aff71b5e901fe0ddcd5f09137302447e295b2c38112"];
                if (!testDef) {
                    this.prof_remove_convert_to_indeed_resume_optionValue_ = -1;
                } else {
                    this.prof_remove_convert_to_indeed_resume_optionValue_ = testDef[0];
                }
                testDef = opt_values["b88c6e8c927433cfaed035ca7e8e2e80df45d184d433daf392df5fc86f77e74d"];
                if (!testDef) {
                    this.pref_location_resume_builder_inValue_ = -1;
                } else {
                    this.pref_location_resume_builder_inValue_ = testDef[0];
                }
                testDef = opt_values["84bc0ca930c0e29e388b36caae82d79c72343393941e02acf67611211085c0e3"];
                if (!testDef) {
                    this.in_resume_builder_education_new_fieldsValue_ = -1;
                } else {
                    this.in_resume_builder_education_new_fieldsValue_ = testDef[0];
                }
                testDef = opt_values["eb4557ea9f1df45f4ddaf7baebd04c89129eae8c8a5d5e41bcd706266dec064f"];
                if (!testDef) {
                    this.prof_data_merge_no_resume_tstValue_ = -1;
                } else {
                    this.prof_data_merge_no_resume_tstValue_ = testDef[0];
                }
                testDef = opt_values["8cd959ddae221592df2558e53d90966f72c962889c0d4505327295989f03b1f9"];
                if (!testDef) {
                    this.iosnative_rich_profilesValue_ = -1;
                } else {
                    this.iosnative_rich_profilesValue_ = testDef[0];
                }
                testDef = opt_values["d2bfae1b9ddd65a61c83d620b1d29ffc3c3842abf4beffa0e5da56870e0483b3"];
                if (!testDef) {
                    this.jso_homepage_preferences_surface_factors_data_tstValue_ = -1;
                } else {
                    this.jso_homepage_preferences_surface_factors_data_tstValue_ = testDef[0];
                }
                testDef = opt_values["e47ad7b8fa86489a26b1567d870ba283330e7c15593e87834c0d7f53f046e551"];
                if (!testDef) {
                    this.jsu_profile_location_component_tstValue_ = -1;
                    this.jsu_profile_location_component_tstPayloadValue_ = {};
                } else {
                    this.jsu_profile_location_component_tstValue_ = testDef[0];
                    this.jsu_profile_location_component_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["6a6beea93477d78ce6c71b11b9ca59edfb03b58de52dc018fb1b829a3b114c02"];
                if (!testDef) {
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = -1;
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = {};
                } else {
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = testDef[0];
                    this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = testDef[1];
                }
                testDef = opt_values["8e4134be7b4ff86bb4bab0357fc6562892f0ec233860a15be100b6794a707d9d"];
                if (!testDef) {
                    this.profile_update_app_banner_togValue_ = -1;
                } else {
                    this.profile_update_app_banner_togValue_ = testDef[0];
                }
                testDef = opt_values["64680ba4b32c5df65822f4a35a1663cea079175aafa0cc8c1500e950d1ce2344"];
                if (!testDef) {
                    this.profile_photos_togValue_ = -1;
                } else {
                    this.profile_photos_togValue_ = testDef[0];
                }
                testDef = opt_values["de79ea17c5aee44e50f85676ced86334de5c6f2cbf83892e7db1e62e63a0a5e7"];
                if (!testDef) {
                    this.prof_fe_merge_second_phaseValue_ = -1;
                } else {
                    this.prof_fe_merge_second_phaseValue_ = testDef[0];
                }
            }
        } else {
            this.eeodp_profile_tstValue_ = -1;
            this.hiredsignal_resume_autocomplete_tstValue_ = -1;
            this.ia_tailored_resume_tstValue_ = -1;
            this.ibu_india_profile_location_area_field_tstValue_ = -1;
            this.ibu_india_resume_discovery_users_tstValue_ = -1;
            this.ibu_jsc_profile_education_tstValue_ = -1;
            this.ibu_jsc_profile_phone_mandatoryValue_ = -1;
            this.ibu_jsc_profile_workexp_tstValue_ = -1;
            this.in_apply_resume_builder_educationValue_ = -1;
            this.in_apply_resume_builder_work_expValue_ = -1;
            this.in_resume_builder_certificationValue_ = -1;
            this.in_resume_builder_currentsalaryValue_ = -1;
            this.in_resume_builder_education_new_fieldsValue_ = -1;
            this.in_resume_builder_language_proficiency_pageValue_ = -1;
            this.in_resume_builder_linksValue_ = -1;
            this.in_resume_builder_work_exp_new_fieldsValue_ = -1;
            this.in_resume_upload_profile_missing_info_tstValue_ = -1;
            this.intl_non_pdf_searchability_lockValue_ = -1;
            this.iosnative_premium_profile_insightsValue_ = -1;
            this.iosnative_rich_profilesValue_ = -1;
            this.itd_india_phoneconsentremoval_tstValue_ = -1;
            this.jcs_big6_tstValue_ = -1;
            this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ = -1;
            this.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_ = {};
            this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ = -1;
            this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_ = {};
            this.jpm_light_profile_pow_tstValue_ = -1;
            this.jpmp_jsg_pow_rag_promo_tstValue_ = -1;
            this.jpmp_jsg_pow_rag_promo_tstPayloadValue_ = {};
            this.jpmp_jsg_use_jobseeker_raw_location_togValue_ = -1;
            this.js_pro_profile_enhancements_tstValue_ = -1;
            this.jsj_crowtaxo_holdout_tstValue_ = -1;
            this.jso_homepage_preferences_surface_factors_data_tstValue_ = -1;
            this.jso_minimal_onboarding_tstValue_ = -1;
            this.jso_resume_option_tstValue_ = -1;
            this.jso_signin_onboarding_tstValue_ = -1;
            this.jso_skipintro_tstValue_ = -1;
            this.jsu_employer_blocking_tstValue_ = -1;
            this.jsu_profile_location_component_tstValue_ = -1;
            this.jsu_profile_location_component_tstPayloadValue_ = {};
            this.mosaic_js_premium_parent_tstValue_ = -1;
            this.myindallowfileonlytoggleValue_ = -1;
            this.myindconvertsavedfiletstValue_ = -1;
            this.myindconvertsavedfiletstPayloadValue_ = {};
            this.myindresumebuildertstValue_ = -1;
            this.pcs_qualifications_disclaimerValue_ = -1;
            this.pet_cpra_donotsellsharelink_tstValue_ = -1;
            this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ = -1;
            this.pow_create_merged_profiles_tstValue_ = -1;
            this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ = -1;
            this.pow_current_salary_page_mvr_builderValue_ = -1;
            this.pow_edu_training_representation_splitValue_ = -1;
            this.pow_europe_builder_flow_tstValue_ = -1;
            this.pow_first_last_name_validationValue_ = -1;
            this.pow_hiredsignal_sourceability_toggle_tstValue_ = -1;
            this.pow_hub_privacy_tstValue_ = -1;
            this.pow_intl_fields_resume_localeValue_ = -1;
            this.pow_invalid_location_prompt_togValue_ = -1;
            this.pow_languages_field_migrationValue_ = -1;
            this.pow_multiple_resume_tstValue_ = -1;
            this.pow_phone_page_mvr_builderValue_ = -1;
            this.pow_privacy_promo_tstValue_ = -1;
            this.pow_prof_resume_privacy_tstValue_ = -1;
            this.pow_re_resume_localeValue_ = -1;
            this.pow_redesign_locale_pickerValue_ = -1;
            this.pow_reusable_pay_component_tstValue_ = -1;
            this.pow_skills_test_deprecationValue_ = -1;
            this.pow_skills_validationValue_ = -1;
            this.pow_work_area_preferences_frontend_tstValue_ = -1;
            this.pow_years_of_experience_resume_builder_inValue_ = -1;
            this.powfrommilitaryparametertoggleValue_ = -1;
            this.powiplphoneinputtstValue_ = -1;
            this.powreviewcompanieslinktoggleValue_ = -1;
            this.pref_location_resume_builder_inValue_ = -1;
            this.prof_auto_resume_sections_schema_tstValue_ = -1;
            this.prof_back_button_label_toggleValue_ = -1;
            this.prof_data_merge_no_resume_tstValue_ = -1;
            this.prof_data_merge_parsed_resume_tstValue_ = -1;
            this.prof_fe_merge_second_phaseValue_ = -1;
            this.prof_jp_no_thumbnailValue_ = -1;
            this.prof_mvp_data_merge_crowtaxo_togValue_ = -1;
            this.prof_mvp_data_merge_crowtaxo_togPayloadValue_ = {};
            this.prof_pdf_confirmationValue_ = -1;
            this.prof_remove_convert_to_indeed_resume_optionValue_ = -1;
            this.prof_sg_work_auth_for_parsed_rez_tstValue_ = -1;
            this.prof_skillset_toggleValue_ = -1;
            this.prof_tabbed_expValue_ = -1;
            this.prof_tabbed_exp_resume_data_importValue_ = -1;
            this.prof_tabbed_exp_resume_import_phaseValue_ = -1;
            this.prof_tabbed_exp_smiley_surveyValue_ = -1;
            this.prof_upload_file_redaction_tstValue_ = -1;
            this.profauto_ci_resume_builder_tstValue_ = -1;
            this.profauto_ci_resume_builder_tstPayloadValue_ = {};
            this.profauto_doc_to_pdf_conversion_tstValue_ = -1;
            this.profauto_minimum_pay_resume_builder_tstValue_ = -1;
            this.profile_add_segmentation_preference_togValue_ = -1;
            this.profile_ai_summary_tstValue_ = -1;
            this.profile_ai_work_description_tstValue_ = -1;
            this.profile_extracted_qualifications_tstValue_ = -1;
            this.profile_one_datadog_rum_toggleValue_ = -1;
            this.profile_one_fullstory_tstValue_ = -1;
            this.profile_one_redesign_preferences_tstValue_ = -1;
            this.profile_phone_simplificationValue_ = -1;
            this.profile_photos_togValue_ = -1;
            this.profile_text_experience_input_tstValue_ = -1;
            this.profile_title_match_autocomplete_dataset_tstValue_ = -1;
            this.profile_title_match_autocomplete_dataset_tstPayloadValue_ = {};
            this.profile_update_app_banner_togValue_ = -1;
            this.profile_yoe_removal_togValue_ = -1;
            this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ = -1;
            this.rdp_pdf_resume_faceliftValue_ = -1;
            this.re_upload_to_replaceValue_ = -1;
            this.segment_selection_india_tstValue_ = -1;
            this.si_profile_education_description_initially_hidden_tstValue_ = -1;
            this.suggestions_ui_update_flowsValue_ = -1;
            this.title_match_autocomplete_logging_togValue_ = -1;
        }
    };


  // EEODP_PROFILE_TST


  /**
   * Bucket value for eeodp_profile_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.eeodp_profile_tstValue_;




  /**
   * Checks if the user is in eeodp_profile_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isEeodp_profile_tstInactive = function() {
    return this.eeodp_profile_tstValue_ === -1;
  };


  /**
   * Checks if the user is in eeodp_profile_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isEeodp_profile_tstActive = function() {
    return this.eeodp_profile_tstValue_ === 1;
  };



  // HIREDSIGNAL_RESUME_AUTOCOMPLETE_TST


  /**
   * Bucket value for hiredsignal_resume_autocomplete_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.hiredsignal_resume_autocomplete_tstValue_;




  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstInactive = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === -1;
  };


  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstControl = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === 0;
  };


  /**
   * Checks if the user is in hiredsignal_resume_autocomplete_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isHiredsignal_resume_autocomplete_tstTest = function() {
    return this.hiredsignal_resume_autocomplete_tstValue_ === 1;
  };



  // IA_TAILORED_RESUME_TST


  /**
   * Bucket value for ia_tailored_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ia_tailored_resume_tstValue_;




  /**
   * Checks if the user is in ia_tailored_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_tailored_resume_tstInactive = function() {
    return this.ia_tailored_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ia_tailored_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_tailored_resume_tstControl = function() {
    return this.ia_tailored_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ia_tailored_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_tailored_resume_tstTest = function() {
    return this.ia_tailored_resume_tstValue_ === 1;
  };


  /**
   * Checks if the user is in ia_tailored_resume_tstForce_eligible.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIa_tailored_resume_tstForce_eligible = function() {
    return this.ia_tailored_resume_tstValue_ === 2;
  };



  // IBU_INDIA_PROFILE_LOCATION_AREA_FIELD_TST


  /**
   * Bucket value for ibu_india_profile_location_area_field_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ibu_india_profile_location_area_field_tstValue_;




  /**
   * Checks if the user is in ibu_india_profile_location_area_field_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_profile_location_area_field_tstInactive = function() {
    return this.ibu_india_profile_location_area_field_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ibu_india_profile_location_area_field_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_profile_location_area_field_tstControl = function() {
    return this.ibu_india_profile_location_area_field_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ibu_india_profile_location_area_field_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_profile_location_area_field_tstTest = function() {
    return this.ibu_india_profile_location_area_field_tstValue_ === 1;
  };



  // IBU_INDIA_RESUME_DISCOVERY_USERS_TST


  /**
   * Bucket value for ibu_india_resume_discovery_users_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ibu_india_resume_discovery_users_tstValue_;




  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstInactive = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstControl = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstTest = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === 1;
  };


  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstGrp2 = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === 2;
  };


  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstGrp3 = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === 3;
  };


  /**
   * Checks if the user is in ibu_india_resume_discovery_users_tstGrp4.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_india_resume_discovery_users_tstGrp4 = function() {
    return this.ibu_india_resume_discovery_users_tstValue_ === 4;
  };



  // IBU_JSC_PROFILE_EDUCATION_TST


  /**
   * Bucket value for ibu_jsc_profile_education_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ibu_jsc_profile_education_tstValue_;




  /**
   * Checks if the user is in ibu_jsc_profile_education_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_education_tstInactive = function() {
    return this.ibu_jsc_profile_education_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_education_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_education_tstControl = function() {
    return this.ibu_jsc_profile_education_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_education_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_education_tstTest = function() {
    return this.ibu_jsc_profile_education_tstValue_ === 1;
  };



  // IBU_JSC_PROFILE_PHONE_MANDATORY


  /**
   * Bucket value for ibu_jsc_profile_phone_mandatory.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ibu_jsc_profile_phone_mandatoryValue_;




  /**
   * Checks if the user is in ibu_jsc_profile_phone_mandatoryInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_phone_mandatoryInactive = function() {
    return this.ibu_jsc_profile_phone_mandatoryValue_ === -1;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_phone_mandatoryControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_phone_mandatoryControl = function() {
    return this.ibu_jsc_profile_phone_mandatoryValue_ === 0;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_phone_mandatoryTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_phone_mandatoryTest = function() {
    return this.ibu_jsc_profile_phone_mandatoryValue_ === 1;
  };



  // IBU_JSC_PROFILE_WORKEXP_TST


  /**
   * Bucket value for ibu_jsc_profile_workexp_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.ibu_jsc_profile_workexp_tstValue_;




  /**
   * Checks if the user is in ibu_jsc_profile_workexp_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_workexp_tstInactive = function() {
    return this.ibu_jsc_profile_workexp_tstValue_ === -1;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_workexp_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_workexp_tstControl = function() {
    return this.ibu_jsc_profile_workexp_tstValue_ === 0;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_workexp_tstTst1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_workexp_tstTst1 = function() {
    return this.ibu_jsc_profile_workexp_tstValue_ === 1;
  };


  /**
   * Checks if the user is in ibu_jsc_profile_workexp_tstTst2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIbu_jsc_profile_workexp_tstTst2 = function() {
    return this.ibu_jsc_profile_workexp_tstValue_ === 2;
  };



  // IN_APPLY_RESUME_BUILDER_EDUCATION


  /**
   * Bucket value for in_apply_resume_builder_education.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_apply_resume_builder_educationValue_;




  /**
   * Checks if the user is in in_apply_resume_builder_educationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_educationInactive = function() {
    return this.in_apply_resume_builder_educationValue_ === -1;
  };


  /**
   * Checks if the user is in in_apply_resume_builder_educationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_educationControl = function() {
    return this.in_apply_resume_builder_educationValue_ === 0;
  };


  /**
   * Checks if the user is in in_apply_resume_builder_educationActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_educationActive = function() {
    return this.in_apply_resume_builder_educationValue_ === 1;
  };



  // IN_APPLY_RESUME_BUILDER_WORK_EXP


  /**
   * Bucket value for in_apply_resume_builder_work_exp.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_apply_resume_builder_work_expValue_;




  /**
   * Checks if the user is in in_apply_resume_builder_work_expInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_work_expInactive = function() {
    return this.in_apply_resume_builder_work_expValue_ === -1;
  };


  /**
   * Checks if the user is in in_apply_resume_builder_work_expControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_work_expControl = function() {
    return this.in_apply_resume_builder_work_expValue_ === 0;
  };


  /**
   * Checks if the user is in in_apply_resume_builder_work_expActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_apply_resume_builder_work_expActive = function() {
    return this.in_apply_resume_builder_work_expValue_ === 1;
  };



  // IN_RESUME_BUILDER_CERTIFICATION


  /**
   * Bucket value for in_resume_builder_certification.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_certificationValue_;




  /**
   * Checks if the user is in in_resume_builder_certificationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationInactive = function() {
    return this.in_resume_builder_certificationValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_certificationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationControl = function() {
    return this.in_resume_builder_certificationValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_certificationGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_certificationGrp1 = function() {
    return this.in_resume_builder_certificationValue_ === 1;
  };



  // IN_RESUME_BUILDER_CURRENTSALARY


  /**
   * Bucket value for in_resume_builder_currentsalary.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_currentsalaryValue_;




  /**
   * Checks if the user is in in_resume_builder_currentsalaryInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_currentsalaryInactive = function() {
    return this.in_resume_builder_currentsalaryValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_currentsalaryControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_currentsalaryControl = function() {
    return this.in_resume_builder_currentsalaryValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_currentsalaryActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_currentsalaryActive = function() {
    return this.in_resume_builder_currentsalaryValue_ === 1;
  };



  // IN_RESUME_BUILDER_EDUCATION_NEW_FIELDS


  /**
   * Bucket value for in_resume_builder_education_new_fields.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_education_new_fieldsValue_;




  /**
   * Checks if the user is in in_resume_builder_education_new_fieldsInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_education_new_fieldsInactive = function() {
    return this.in_resume_builder_education_new_fieldsValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_education_new_fieldsControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_education_new_fieldsControl = function() {
    return this.in_resume_builder_education_new_fieldsValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_education_new_fieldsGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_education_new_fieldsGrp1 = function() {
    return this.in_resume_builder_education_new_fieldsValue_ === 1;
  };


  /**
   * Checks if the user is in in_resume_builder_education_new_fieldsGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_education_new_fieldsGrp2 = function() {
    return this.in_resume_builder_education_new_fieldsValue_ === 2;
  };



  // IN_RESUME_BUILDER_LANGUAGE_PROFICIENCY_PAGE


  /**
   * Bucket value for in_resume_builder_language_proficiency_page.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_language_proficiency_pageValue_;




  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageInactive = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageControl = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageGrp1 = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 1;
  };


  /**
   * Checks if the user is in in_resume_builder_language_proficiency_pageGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_language_proficiency_pageGrp2 = function() {
    return this.in_resume_builder_language_proficiency_pageValue_ === 2;
  };



  // IN_RESUME_BUILDER_LINKS


  /**
   * Bucket value for in_resume_builder_links.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_linksValue_;




  /**
   * Checks if the user is in in_resume_builder_linksInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_linksInactive = function() {
    return this.in_resume_builder_linksValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_linksControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_linksControl = function() {
    return this.in_resume_builder_linksValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_linksGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_linksGrp1 = function() {
    return this.in_resume_builder_linksValue_ === 1;
  };



  // IN_RESUME_BUILDER_WORK_EXP_NEW_FIELDS


  /**
   * Bucket value for in_resume_builder_work_exp_new_fields.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_builder_work_exp_new_fieldsValue_;




  /**
   * Checks if the user is in in_resume_builder_work_exp_new_fieldsInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_work_exp_new_fieldsInactive = function() {
    return this.in_resume_builder_work_exp_new_fieldsValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_builder_work_exp_new_fieldsControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_work_exp_new_fieldsControl = function() {
    return this.in_resume_builder_work_exp_new_fieldsValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_builder_work_exp_new_fieldsGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_work_exp_new_fieldsGrp1 = function() {
    return this.in_resume_builder_work_exp_new_fieldsValue_ === 1;
  };


  /**
   * Checks if the user is in in_resume_builder_work_exp_new_fieldsGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_builder_work_exp_new_fieldsGrp2 = function() {
    return this.in_resume_builder_work_exp_new_fieldsValue_ === 2;
  };



  // IN_RESUME_UPLOAD_PROFILE_MISSING_INFO_TST


  /**
   * Bucket value for in_resume_upload_profile_missing_info_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.in_resume_upload_profile_missing_info_tstValue_;




  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstInactive = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === -1;
  };


  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstControl = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === 0;
  };


  /**
   * Checks if the user is in in_resume_upload_profile_missing_info_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIn_resume_upload_profile_missing_info_tstTest = function() {
    return this.in_resume_upload_profile_missing_info_tstValue_ === 1;
  };



  // INTL_NON_PDF_SEARCHABILITY_LOCK


  /**
   * Bucket value for intl_non_pdf_searchability_lock.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.intl_non_pdf_searchability_lockValue_;




  /**
   * Checks if the user is in intl_non_pdf_searchability_lockInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockInactive = function() {
    return this.intl_non_pdf_searchability_lockValue_ === -1;
  };


  /**
   * Checks if the user is in intl_non_pdf_searchability_lockControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockControl = function() {
    return this.intl_non_pdf_searchability_lockValue_ === 0;
  };


  /**
   * Checks if the user is in intl_non_pdf_searchability_lockActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIntl_non_pdf_searchability_lockActive = function() {
    return this.intl_non_pdf_searchability_lockValue_ === 1;
  };



  // IOSNATIVE_PREMIUM_PROFILE_INSIGHTS


  /**
   * Bucket value for iosnative_premium_profile_insights.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.iosnative_premium_profile_insightsValue_;




  /**
   * Checks if the user is in iosnative_premium_profile_insightsInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsInactive = function() {
    return this.iosnative_premium_profile_insightsValue_ === -1;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsControl = function() {
    return this.iosnative_premium_profile_insightsValue_ === 0;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsControl_aa.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsControl_aa = function() {
    return this.iosnative_premium_profile_insightsValue_ === 1;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsActive = function() {
    return this.iosnative_premium_profile_insightsValue_ === 2;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPremium_branding.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPremium_branding = function() {
    return this.iosnative_premium_profile_insightsValue_ === 3;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_b_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_b_control = function() {
    return this.iosnative_premium_profile_insightsValue_ === 4;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_b.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_b = function() {
    return this.iosnative_premium_profile_insightsValue_ === 5;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_c_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_c_control = function() {
    return this.iosnative_premium_profile_insightsValue_ === 6;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsPhase_c.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsPhase_c = function() {
    return this.iosnative_premium_profile_insightsValue_ === 7;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_f.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_f = function() {
    return this.iosnative_premium_profile_insightsValue_ === 8;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_g.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_g = function() {
    return this.iosnative_premium_profile_insightsValue_ === 9;
  };


  /**
   * Checks if the user is in iosnative_premium_profile_insightsReserved_h.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_premium_profile_insightsReserved_h = function() {
    return this.iosnative_premium_profile_insightsValue_ === 10;
  };



  // IOSNATIVE_RICH_PROFILES


  /**
   * Bucket value for iosnative_rich_profiles.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.iosnative_rich_profilesValue_;




  /**
   * Checks if the user is in iosnative_rich_profilesInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesInactive = function() {
    return this.iosnative_rich_profilesValue_ === -1;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesControl = function() {
    return this.iosnative_rich_profilesValue_ === 0;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesControl_aa.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesControl_aa = function() {
    return this.iosnative_rich_profilesValue_ === 1;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesPhase_a_active.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesPhase_a_active = function() {
    return this.iosnative_rich_profilesValue_ === 2;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesPhase_a_reserved.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesPhase_a_reserved = function() {
    return this.iosnative_rich_profilesValue_ === 3;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesTaxonomy_fetch_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesTaxonomy_fetch_control = function() {
    return this.iosnative_rich_profilesValue_ === 4;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesTaxonomy_fetch.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesTaxonomy_fetch = function() {
    return this.iosnative_rich_profilesValue_ === 5;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_c_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_c_control = function() {
    return this.iosnative_rich_profilesValue_ === 6;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_c.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_c = function() {
    return this.iosnative_rich_profilesValue_ === 7;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_d_control.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_d_control = function() {
    return this.iosnative_rich_profilesValue_ === 8;
  };


  /**
   * Checks if the user is in iosnative_rich_profilesReserved_d.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isIosnative_rich_profilesReserved_d = function() {
    return this.iosnative_rich_profilesValue_ === 9;
  };



  // ITD_INDIA_PHONECONSENTREMOVAL_TST


  /**
   * Bucket value for itd_india_phoneconsentremoval_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.itd_india_phoneconsentremoval_tstValue_;




  /**
   * Checks if the user is in itd_india_phoneconsentremoval_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isItd_india_phoneconsentremoval_tstInactive = function() {
    return this.itd_india_phoneconsentremoval_tstValue_ === -1;
  };


  /**
   * Checks if the user is in itd_india_phoneconsentremoval_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isItd_india_phoneconsentremoval_tstControl = function() {
    return this.itd_india_phoneconsentremoval_tstValue_ === 0;
  };


  /**
   * Checks if the user is in itd_india_phoneconsentremoval_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isItd_india_phoneconsentremoval_tstTest = function() {
    return this.itd_india_phoneconsentremoval_tstValue_ === 1;
  };



  // JCS_BIG6_TST


  /**
   * Bucket value for jcs_big6_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jcs_big6_tstValue_;




  /**
   * Checks if the user is in jcs_big6_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstInactive = function() {
    return this.jcs_big6_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jcs_big6_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstControl = function() {
    return this.jcs_big6_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jcs_big6_tstVisualChanges.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstVisualChanges = function() {
    return this.jcs_big6_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jcs_big6_tstComboMeta.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstComboMeta = function() {
    return this.jcs_big6_tstValue_ === 2;
  };


  /**
   * Checks if the user is in jcs_big6_tstShifts.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstShifts = function() {
    return this.jcs_big6_tstValue_ === 3;
  };


  /**
   * Checks if the user is in jcs_big6_tstCommute.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstCommute = function() {
    return this.jcs_big6_tstValue_ === 4;
  };


  /**
   * Checks if the user is in jcs_big6_tstScheduleCC.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstScheduleCC = function() {
    return this.jcs_big6_tstValue_ === 5;
  };


  /**
   * Checks if the user is in jcs_big6_tstCommuteAndScheduleCC.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJcs_big6_tstCommuteAndScheduleCC = function() {
    return this.jcs_big6_tstValue_ === 6;
  };



  // JPE_CROWTAGS_RESUME_FLOW_OCCUPATION_AUTOCOMPLETE_TST


  /**
   * Bucket value for jpe_crowtags_resume_flow_occupation_autocomplete_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_;


  /**
   * Payload value for jpe_crowtags_resume_flow_occupation_autocomplete_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_;


  /**
   * Get the payload value for jpe_crowtags_resume_flow_occupation_autocomplete_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue = function() {
    return this.jpe_crowtags_resume_flow_occupation_autocomplete_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autocomplete_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autocomplete_tstInactive = function() {
    return this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autocomplete_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autocomplete_tstControl = function() {
    return this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autocomplete_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autocomplete_tstTest = function() {
    return this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autocomplete_tstTest2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autocomplete_tstTest2 = function() {
    return this.jpe_crowtags_resume_flow_occupation_autocomplete_tstValue_ === 2;
  };



  // JPE_CROWTAGS_RESUME_FLOW_OCCUPATION_AUTOSUGGESTION_TST


  /**
   * Bucket value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_;


  /**
   * Payload value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_;


  /**
   * Get the payload value for jpe_crowtags_resume_flow_occupation_autosuggestion_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstInactive = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstControl = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpe_crowtags_resume_flow_occupation_autosuggestion_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpe_crowtags_resume_flow_occupation_autosuggestion_tstTest = function() {
    return this.jpe_crowtags_resume_flow_occupation_autosuggestion_tstValue_ === 1;
  };



  // JPM_LIGHT_PROFILE_POW_TST


  /**
   * Bucket value for jpm_light_profile_pow_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpm_light_profile_pow_tstValue_;




  /**
   * Checks if the user is in jpm_light_profile_pow_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_light_profile_pow_tstInactive = function() {
    return this.jpm_light_profile_pow_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpm_light_profile_pow_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_light_profile_pow_tstControl = function() {
    return this.jpm_light_profile_pow_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpm_light_profile_pow_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpm_light_profile_pow_tstTest = function() {
    return this.jpm_light_profile_pow_tstValue_ === 1;
  };



  // JPMP_JSG_POW_RAG_PROMO_TST


  /**
   * Bucket value for jpmp_jsg_pow_rag_promo_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_pow_rag_promo_tstValue_;


  /**
   * Payload value for jpmp_jsg_pow_rag_promo_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_pow_rag_promo_tstPayloadValue_;


  /**
   * Get the payload value for jpmp_jsg_pow_rag_promo_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJpmp_jsg_pow_rag_promo_tstPayloadValue = function() {
    return this.jpmp_jsg_pow_rag_promo_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstInactive = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstControl = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstFulltimeShort.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstFulltimeShort = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstAllShort.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstAllShort = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 2;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstFulltimeLong.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstFulltimeLong = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 3;
  };


  /**
   * Checks if the user is in jpmp_jsg_pow_rag_promo_tstAllLong.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_pow_rag_promo_tstAllLong = function() {
    return this.jpmp_jsg_pow_rag_promo_tstValue_ === 4;
  };



  // JPMP_JSG_USE_JOBSEEKER_RAW_LOCATION_TOG


  /**
   * Bucket value for jpmp_jsg_use_jobseeker_raw_location_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jpmp_jsg_use_jobseeker_raw_location_togValue_;




  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togInactive = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === -1;
  };


  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togControl = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === 0;
  };


  /**
   * Checks if the user is in jpmp_jsg_use_jobseeker_raw_location_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJpmp_jsg_use_jobseeker_raw_location_togTest = function() {
    return this.jpmp_jsg_use_jobseeker_raw_location_togValue_ === 1;
  };



  // JS_PRO_PROFILE_ENHANCEMENTS_TST


  /**
   * Bucket value for js_pro_profile_enhancements_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.js_pro_profile_enhancements_tstValue_;




  /**
   * Checks if the user is in js_pro_profile_enhancements_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstInactive = function() {
    return this.js_pro_profile_enhancements_tstValue_ === -1;
  };


  /**
   * Checks if the user is in js_pro_profile_enhancements_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstControl = function() {
    return this.js_pro_profile_enhancements_tstValue_ === 0;
  };


  /**
   * Checks if the user is in js_pro_profile_enhancements_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJs_pro_profile_enhancements_tstTest = function() {
    return this.js_pro_profile_enhancements_tstValue_ === 1;
  };



  // JSJ_CROWTAXO_HOLDOUT_TST


  /**
   * Bucket value for jsj_crowtaxo_holdout_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsj_crowtaxo_holdout_tstValue_;




  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstInactive = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstControl = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstHoldout.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstHoldout = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jsj_crowtaxo_holdout_tstCrowtaxo.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsj_crowtaxo_holdout_tstCrowtaxo = function() {
    return this.jsj_crowtaxo_holdout_tstValue_ === 2;
  };



  // JSO_HOMEPAGE_PREFERENCES_SURFACE_FACTORS_DATA_TST


  /**
   * Bucket value for jso_homepage_preferences_surface_factors_data_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_homepage_preferences_surface_factors_data_tstValue_;




  /**
   * Checks if the user is in jso_homepage_preferences_surface_factors_data_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_homepage_preferences_surface_factors_data_tstInactive = function() {
    return this.jso_homepage_preferences_surface_factors_data_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_homepage_preferences_surface_factors_data_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_homepage_preferences_surface_factors_data_tstControl = function() {
    return this.jso_homepage_preferences_surface_factors_data_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_homepage_preferences_surface_factors_data_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_homepage_preferences_surface_factors_data_tstTest = function() {
    return this.jso_homepage_preferences_surface_factors_data_tstValue_ === 1;
  };



  // JSO_MINIMAL_ONBOARDING_TST


  /**
   * Bucket value for jso_minimal_onboarding_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_minimal_onboarding_tstValue_;




  /**
   * Checks if the user is in jso_minimal_onboarding_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstInactive = function() {
    return this.jso_minimal_onboarding_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstControl = function() {
    return this.jso_minimal_onboarding_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstTest = function() {
    return this.jso_minimal_onboarding_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jso_minimal_onboarding_tstHomepageRedirect.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_minimal_onboarding_tstHomepageRedirect = function() {
    return this.jso_minimal_onboarding_tstValue_ === 2;
  };



  // JSO_RESUME_OPTION_TST


  /**
   * Bucket value for jso_resume_option_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_resume_option_tstValue_;




  /**
   * Checks if the user is in jso_resume_option_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_resume_option_tstInactive = function() {
    return this.jso_resume_option_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_resume_option_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_resume_option_tstControl = function() {
    return this.jso_resume_option_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_resume_option_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_resume_option_tstTest = function() {
    return this.jso_resume_option_tstValue_ === 1;
  };



  // JSO_SIGNIN_ONBOARDING_TST


  /**
   * Bucket value for jso_signin_onboarding_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_signin_onboarding_tstValue_;




  /**
   * Checks if the user is in jso_signin_onboarding_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_signin_onboarding_tstInactive = function() {
    return this.jso_signin_onboarding_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_signin_onboarding_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_signin_onboarding_tstControl = function() {
    return this.jso_signin_onboarding_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_signin_onboarding_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_signin_onboarding_tstTest = function() {
    return this.jso_signin_onboarding_tstValue_ === 1;
  };



  // JSO_SKIPINTRO_TST


  /**
   * Bucket value for jso_skipintro_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jso_skipintro_tstValue_;




  /**
   * Checks if the user is in jso_skipintro_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_skipintro_tstInactive = function() {
    return this.jso_skipintro_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jso_skipintro_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_skipintro_tstControl = function() {
    return this.jso_skipintro_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jso_skipintro_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJso_skipintro_tstActive = function() {
    return this.jso_skipintro_tstValue_ === 1;
  };



  // JSU_EMPLOYER_BLOCKING_TST


  /**
   * Bucket value for jsu_employer_blocking_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_employer_blocking_tstValue_;




  /**
   * Checks if the user is in jsu_employer_blocking_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstInactive = function() {
    return this.jsu_employer_blocking_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsu_employer_blocking_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstControl = function() {
    return this.jsu_employer_blocking_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsu_employer_blocking_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_employer_blocking_tstTest = function() {
    return this.jsu_employer_blocking_tstValue_ === 1;
  };



  // JSU_PROFILE_LOCATION_COMPONENT_TST


  /**
   * Bucket value for jsu_profile_location_component_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_profile_location_component_tstValue_;


  /**
   * Payload value for jsu_profile_location_component_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.jsu_profile_location_component_tstPayloadValue_;


  /**
   * Get the payload value for jsu_profile_location_component_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getJsu_profile_location_component_tstPayloadValue = function() {
    return this.jsu_profile_location_component_tstPayloadValue_;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstInactive = function() {
    return this.jsu_profile_location_component_tstValue_ === -1;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstControl = function() {
    return this.jsu_profile_location_component_tstValue_ === 0;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpIN.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpIN = function() {
    return this.jsu_profile_location_component_tstValue_ === 1;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpJP.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpJP = function() {
    return this.jsu_profile_location_component_tstValue_ === 2;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpA.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpA = function() {
    return this.jsu_profile_location_component_tstValue_ === 3;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpB.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpB = function() {
    return this.jsu_profile_location_component_tstValue_ === 4;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstGrpC.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstGrpC = function() {
    return this.jsu_profile_location_component_tstValue_ === 5;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstResumeFlow.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstResumeFlow = function() {
    return this.jsu_profile_location_component_tstValue_ === 6;
  };


  /**
   * Checks if the user is in jsu_profile_location_component_tstResumeFlowControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isJsu_profile_location_component_tstResumeFlowControl = function() {
    return this.jsu_profile_location_component_tstValue_ === 7;
  };



  // MOSAIC_JS_PREMIUM_PARENT_TST


  /**
   * Bucket value for mosaic_js_premium_parent_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.mosaic_js_premium_parent_tstValue_;




  /**
   * Checks if the user is in mosaic_js_premium_parent_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstInactive = function() {
    return this.mosaic_js_premium_parent_tstValue_ === -1;
  };


  /**
   * Checks if the user is in mosaic_js_premium_parent_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstControl = function() {
    return this.mosaic_js_premium_parent_tstValue_ === 0;
  };


  /**
   * Checks if the user is in mosaic_js_premium_parent_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMosaic_js_premium_parent_tstActive = function() {
    return this.mosaic_js_premium_parent_tstValue_ === 1;
  };



  // MYINDALLOWFILEONLYTOGGLE


  /**
   * Bucket value for myindallowfileonlytoggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.myindallowfileonlytoggleValue_;




  /**
   * Checks if the user is in myindallowfileonlytoggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleInactive = function() {
    return this.myindallowfileonlytoggleValue_ === -1;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleControl = function() {
    return this.myindallowfileonlytoggleValue_ === 0;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleActive = function() {
    return this.myindallowfileonlytoggleValue_ === 1;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleDefaultPublic.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleDefaultPublic = function() {
    return this.myindallowfileonlytoggleValue_ === 2;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleAutoPublic.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleAutoPublic = function() {
    return this.myindallowfileonlytoggleValue_ === 3;
  };


  /**
   * Checks if the user is in myindallowfileonlytoggleControlWithPrivacy.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindallowfileonlytoggleControlWithPrivacy = function() {
    return this.myindallowfileonlytoggleValue_ === 4;
  };



  // MYINDCONVERTSAVEDFILETST


  /**
   * Bucket value for myindconvertsavedfiletst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.myindconvertsavedfiletstValue_;


  /**
   * Payload value for myindconvertsavedfiletst.
   * @type {Object.<string, Object>}
   * @private
   */
  ProfileProctorGroups_.prototype.myindconvertsavedfiletstPayloadValue_;


  /**
   * Get the payload value for myindconvertsavedfiletst.
   * @return {Object.<string, Object>}
   */
  ProfileProctorGroups_.prototype.getMyindconvertsavedfiletstPayloadValue = function() {
    return this.myindconvertsavedfiletstPayloadValue_;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstInactive = function() {
    return this.myindconvertsavedfiletstValue_ === -1;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstControl = function() {
    return this.myindconvertsavedfiletstValue_ === 0;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstActive = function() {
    return this.myindconvertsavedfiletstValue_ === 1;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstGrp2 = function() {
    return this.myindconvertsavedfiletstValue_ === 2;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstGrp3 = function() {
    return this.myindconvertsavedfiletstValue_ === 3;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstGrp4.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstGrp4 = function() {
    return this.myindconvertsavedfiletstValue_ === 4;
  };


  /**
   * Checks if the user is in myindconvertsavedfiletstGrp5.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindconvertsavedfiletstGrp5 = function() {
    return this.myindconvertsavedfiletstValue_ === 5;
  };



  // MYINDRESUMEBUILDERTST


  /**
   * Bucket value for myindresumebuildertst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.myindresumebuildertstValue_;




  /**
   * Checks if the user is in myindresumebuildertstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstInactive = function() {
    return this.myindresumebuildertstValue_ === -1;
  };


  /**
   * Checks if the user is in myindresumebuildertstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstControl = function() {
    return this.myindresumebuildertstValue_ === 0;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp1 = function() {
    return this.myindresumebuildertstValue_ === 1;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp2 = function() {
    return this.myindresumebuildertstValue_ === 2;
  };


  /**
   * Checks if the user is in myindresumebuildertstGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isMyindresumebuildertstGrp3 = function() {
    return this.myindresumebuildertstValue_ === 3;
  };



  // PCS_QUALIFICATIONS_DISCLAIMER


  /**
   * Bucket value for pcs_qualifications_disclaimer.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pcs_qualifications_disclaimerValue_;




  /**
   * Checks if the user is in pcs_qualifications_disclaimerInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerInactive = function() {
    return this.pcs_qualifications_disclaimerValue_ === -1;
  };


  /**
   * Checks if the user is in pcs_qualifications_disclaimerControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerControl = function() {
    return this.pcs_qualifications_disclaimerValue_ === 0;
  };


  /**
   * Checks if the user is in pcs_qualifications_disclaimerTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPcs_qualifications_disclaimerTest = function() {
    return this.pcs_qualifications_disclaimerValue_ === 1;
  };



  // PET_CPRA_DONOTSELLSHARELINK_TST


  /**
   * Bucket value for pet_cpra_donotsellsharelink_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pet_cpra_donotsellsharelink_tstValue_;




  /**
   * Checks if the user is in pet_cpra_donotsellsharelink_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPet_cpra_donotsellsharelink_tstInactive = function() {
    return this.pet_cpra_donotsellsharelink_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pet_cpra_donotsellsharelink_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPet_cpra_donotsellsharelink_tstActive = function() {
    return this.pet_cpra_donotsellsharelink_tstValue_ === 1;
  };



  // POW_CREATE_JOB_SEEKER_PROFILE_RESUME_FILE_TEMP_URL_PASSES_FILE_ID


  /**
   * Bucket value for pow_createJobSeekerProfileResumeFileTempUrl_passes_fileId.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_;




  /**
   * Checks if the user is in pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdInactive = function() {
    return this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ === -1;
  };


  /**
   * Checks if the user is in pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdControl = function() {
    return this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ === 0;
  };


  /**
   * Checks if the user is in pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdTest = function() {
    return this.pow_createJobSeekerProfileResumeFileTempUrl_passes_fileIdValue_ === 1;
  };



  // POW_CREATE_MERGED_PROFILES_TST


  /**
   * Bucket value for pow_create_merged_profiles_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_create_merged_profiles_tstValue_;




  /**
   * Checks if the user is in pow_create_merged_profiles_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstInactive = function() {
    return this.pow_create_merged_profiles_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_create_merged_profiles_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstControl = function() {
    return this.pow_create_merged_profiles_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_create_merged_profiles_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_create_merged_profiles_tstTest = function() {
    return this.pow_create_merged_profiles_tstValue_ === 1;
  };



  // POW_CROWTAXO_WORK_WELLBEING_PREFERENCES_FRONTEND_TST


  /**
   * Bucket value for pow_crowtaxo_work_wellbeing_preferences_frontend_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_;




  /**
   * Checks if the user is in pow_crowtaxo_work_wellbeing_preferences_frontend_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_work_wellbeing_preferences_frontend_tstInactive = function() {
    return this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_crowtaxo_work_wellbeing_preferences_frontend_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_work_wellbeing_preferences_frontend_tstControl = function() {
    return this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_crowtaxo_work_wellbeing_preferences_frontend_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_crowtaxo_work_wellbeing_preferences_frontend_tstTest = function() {
    return this.pow_crowtaxo_work_wellbeing_preferences_frontend_tstValue_ === 1;
  };



  // POW_CURRENT_SALARY_PAGE_MVR_BUILDER


  /**
   * Bucket value for pow_current_salary_page_mvr_builder.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_current_salary_page_mvr_builderValue_;




  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderInactive = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === -1;
  };


  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderControl = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === 0;
  };


  /**
   * Checks if the user is in pow_current_salary_page_mvr_builderTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_current_salary_page_mvr_builderTest = function() {
    return this.pow_current_salary_page_mvr_builderValue_ === 1;
  };



  // POW_EDU_TRAINING_REPRESENTATION_SPLIT


  /**
   * Bucket value for pow_edu_training_representation_split.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_edu_training_representation_splitValue_;




  /**
   * Checks if the user is in pow_edu_training_representation_splitInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitInactive = function() {
    return this.pow_edu_training_representation_splitValue_ === -1;
  };


  /**
   * Checks if the user is in pow_edu_training_representation_splitControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitControl = function() {
    return this.pow_edu_training_representation_splitValue_ === 0;
  };


  /**
   * Checks if the user is in pow_edu_training_representation_splitTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_edu_training_representation_splitTest = function() {
    return this.pow_edu_training_representation_splitValue_ === 1;
  };



  // POW_EUROPE_BUILDER_FLOW_TST


  /**
   * Bucket value for pow_europe_builder_flow_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_europe_builder_flow_tstValue_;




  /**
   * Checks if the user is in pow_europe_builder_flow_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstInactive = function() {
    return this.pow_europe_builder_flow_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_europe_builder_flow_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstControl = function() {
    return this.pow_europe_builder_flow_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_europe_builder_flow_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_europe_builder_flow_tstTest = function() {
    return this.pow_europe_builder_flow_tstValue_ === 1;
  };



  // POW_FIRST_LAST_NAME_VALIDATION


  /**
   * Bucket value for pow_first_last_name_validation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_first_last_name_validationValue_;




  /**
   * Checks if the user is in pow_first_last_name_validationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationInactive = function() {
    return this.pow_first_last_name_validationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_first_last_name_validationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationControl = function() {
    return this.pow_first_last_name_validationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_first_last_name_validationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_first_last_name_validationTest = function() {
    return this.pow_first_last_name_validationValue_ === 1;
  };



  // POW_HIREDSIGNAL_SOURCEABILITY_TOGGLE_TST


  /**
   * Bucket value for pow_hiredsignal_sourceability_toggle_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_hiredsignal_sourceability_toggle_tstValue_;




  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstInactive = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstControl = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_hiredsignal_sourceability_toggle_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hiredsignal_sourceability_toggle_tstTest = function() {
    return this.pow_hiredsignal_sourceability_toggle_tstValue_ === 1;
  };



  // POW_HUB_PRIVACY_TST


  /**
   * Bucket value for pow_hub_privacy_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_hub_privacy_tstValue_;




  /**
   * Checks if the user is in pow_hub_privacy_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hub_privacy_tstInactive = function() {
    return this.pow_hub_privacy_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_hub_privacy_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hub_privacy_tstControl = function() {
    return this.pow_hub_privacy_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_hub_privacy_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_hub_privacy_tstTest = function() {
    return this.pow_hub_privacy_tstValue_ === 1;
  };



  // POW_INTL_FIELDS_RESUME_LOCALE


  /**
   * Bucket value for pow_intl_fields_resume_locale.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_intl_fields_resume_localeValue_;




  /**
   * Checks if the user is in pow_intl_fields_resume_localeInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeInactive = function() {
    return this.pow_intl_fields_resume_localeValue_ === -1;
  };


  /**
   * Checks if the user is in pow_intl_fields_resume_localeControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeControl = function() {
    return this.pow_intl_fields_resume_localeValue_ === 0;
  };


  /**
   * Checks if the user is in pow_intl_fields_resume_localeTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_intl_fields_resume_localeTest = function() {
    return this.pow_intl_fields_resume_localeValue_ === 1;
  };



  // POW_INVALID_LOCATION_PROMPT_TOG


  /**
   * Bucket value for pow_invalid_location_prompt_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_invalid_location_prompt_togValue_;




  /**
   * Checks if the user is in pow_invalid_location_prompt_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_invalid_location_prompt_togInactive = function() {
    return this.pow_invalid_location_prompt_togValue_ === -1;
  };


  /**
   * Checks if the user is in pow_invalid_location_prompt_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_invalid_location_prompt_togControl = function() {
    return this.pow_invalid_location_prompt_togValue_ === 0;
  };


  /**
   * Checks if the user is in pow_invalid_location_prompt_togActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_invalid_location_prompt_togActive = function() {
    return this.pow_invalid_location_prompt_togValue_ === 1;
  };



  // POW_LANGUAGES_FIELD_MIGRATION


  /**
   * Bucket value for pow_languages_field_migration.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_languages_field_migrationValue_;




  /**
   * Checks if the user is in pow_languages_field_migrationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationInactive = function() {
    return this.pow_languages_field_migrationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_languages_field_migrationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationControl = function() {
    return this.pow_languages_field_migrationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_languages_field_migrationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_languages_field_migrationTest = function() {
    return this.pow_languages_field_migrationValue_ === 1;
  };



  // POW_MULTIPLE_RESUME_TST


  /**
   * Bucket value for pow_multiple_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_multiple_resume_tstValue_;




  /**
   * Checks if the user is in pow_multiple_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstInactive = function() {
    return this.pow_multiple_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_multiple_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstControl = function() {
    return this.pow_multiple_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_multiple_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_multiple_resume_tstTest = function() {
    return this.pow_multiple_resume_tstValue_ === 1;
  };



  // POW_PHONE_PAGE_MVR_BUILDER


  /**
   * Bucket value for pow_phone_page_mvr_builder.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_phone_page_mvr_builderValue_;




  /**
   * Checks if the user is in pow_phone_page_mvr_builderInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderInactive = function() {
    return this.pow_phone_page_mvr_builderValue_ === -1;
  };


  /**
   * Checks if the user is in pow_phone_page_mvr_builderControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderControl = function() {
    return this.pow_phone_page_mvr_builderValue_ === 0;
  };


  /**
   * Checks if the user is in pow_phone_page_mvr_builderTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_phone_page_mvr_builderTest = function() {
    return this.pow_phone_page_mvr_builderValue_ === 1;
  };



  // POW_PRIVACY_PROMO_TST


  /**
   * Bucket value for pow_privacy_promo_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_privacy_promo_tstValue_;




  /**
   * Checks if the user is in pow_privacy_promo_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstInactive = function() {
    return this.pow_privacy_promo_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_privacy_promo_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstControl = function() {
    return this.pow_privacy_promo_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_privacy_promo_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_privacy_promo_tstActive = function() {
    return this.pow_privacy_promo_tstValue_ === 1;
  };



  // POW_PROF_RESUME_PRIVACY_TST


  /**
   * Bucket value for pow_prof_resume_privacy_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_prof_resume_privacy_tstValue_;




  /**
   * Checks if the user is in pow_prof_resume_privacy_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_prof_resume_privacy_tstInactive = function() {
    return this.pow_prof_resume_privacy_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_prof_resume_privacy_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_prof_resume_privacy_tstControl = function() {
    return this.pow_prof_resume_privacy_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_prof_resume_privacy_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_prof_resume_privacy_tstTest = function() {
    return this.pow_prof_resume_privacy_tstValue_ === 1;
  };



  // POW_RE_RESUME_LOCALE


  /**
   * Bucket value for pow_re_resume_locale.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_re_resume_localeValue_;




  /**
   * Checks if the user is in pow_re_resume_localeInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeInactive = function() {
    return this.pow_re_resume_localeValue_ === -1;
  };


  /**
   * Checks if the user is in pow_re_resume_localeControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeControl = function() {
    return this.pow_re_resume_localeValue_ === 0;
  };


  /**
   * Checks if the user is in pow_re_resume_localeTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_re_resume_localeTest = function() {
    return this.pow_re_resume_localeValue_ === 1;
  };



  // POW_REDESIGN_LOCALE_PICKER


  /**
   * Bucket value for pow_redesign_locale_picker.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_redesign_locale_pickerValue_;




  /**
   * Checks if the user is in pow_redesign_locale_pickerInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerInactive = function() {
    return this.pow_redesign_locale_pickerValue_ === -1;
  };


  /**
   * Checks if the user is in pow_redesign_locale_pickerControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerControl = function() {
    return this.pow_redesign_locale_pickerValue_ === 0;
  };


  /**
   * Checks if the user is in pow_redesign_locale_pickerTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_redesign_locale_pickerTest = function() {
    return this.pow_redesign_locale_pickerValue_ === 1;
  };



  // POW_REUSABLE_PAY_COMPONENT_TST


  /**
   * Bucket value for pow_reusable_pay_component_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_reusable_pay_component_tstValue_;




  /**
   * Checks if the user is in pow_reusable_pay_component_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstInactive = function() {
    return this.pow_reusable_pay_component_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_reusable_pay_component_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstControl = function() {
    return this.pow_reusable_pay_component_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_reusable_pay_component_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_reusable_pay_component_tstTest = function() {
    return this.pow_reusable_pay_component_tstValue_ === 1;
  };



  // POW_SKILLS_TEST_DEPRECATION


  /**
   * Bucket value for pow_skills_test_deprecation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_skills_test_deprecationValue_;




  /**
   * Checks if the user is in pow_skills_test_deprecationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationInactive = function() {
    return this.pow_skills_test_deprecationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationControl = function() {
    return this.pow_skills_test_deprecationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationBanner.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationBanner = function() {
    return this.pow_skills_test_deprecationValue_ === 1;
  };


  /**
   * Checks if the user is in pow_skills_test_deprecationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_test_deprecationTest = function() {
    return this.pow_skills_test_deprecationValue_ === 2;
  };



  // POW_SKILLS_VALIDATION


  /**
   * Bucket value for pow_skills_validation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_skills_validationValue_;




  /**
   * Checks if the user is in pow_skills_validationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationInactive = function() {
    return this.pow_skills_validationValue_ === -1;
  };


  /**
   * Checks if the user is in pow_skills_validationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationControl = function() {
    return this.pow_skills_validationValue_ === 0;
  };


  /**
   * Checks if the user is in pow_skills_validationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_skills_validationTest = function() {
    return this.pow_skills_validationValue_ === 1;
  };



  // POW_WORK_AREA_PREFERENCES_FRONTEND_TST


  /**
   * Bucket value for pow_work_area_preferences_frontend_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_work_area_preferences_frontend_tstValue_;




  /**
   * Checks if the user is in pow_work_area_preferences_frontend_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_work_area_preferences_frontend_tstInactive = function() {
    return this.pow_work_area_preferences_frontend_tstValue_ === -1;
  };


  /**
   * Checks if the user is in pow_work_area_preferences_frontend_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_work_area_preferences_frontend_tstControl = function() {
    return this.pow_work_area_preferences_frontend_tstValue_ === 0;
  };


  /**
   * Checks if the user is in pow_work_area_preferences_frontend_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_work_area_preferences_frontend_tstTest = function() {
    return this.pow_work_area_preferences_frontend_tstValue_ === 1;
  };



  // POW_YEARS_OF_EXPERIENCE_RESUME_BUILDER_IN


  /**
   * Bucket value for pow_years_of_experience_resume_builder_in.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pow_years_of_experience_resume_builder_inValue_;




  /**
   * Checks if the user is in pow_years_of_experience_resume_builder_inInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_years_of_experience_resume_builder_inInactive = function() {
    return this.pow_years_of_experience_resume_builder_inValue_ === -1;
  };


  /**
   * Checks if the user is in pow_years_of_experience_resume_builder_inControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_years_of_experience_resume_builder_inControl = function() {
    return this.pow_years_of_experience_resume_builder_inValue_ === 0;
  };


  /**
   * Checks if the user is in pow_years_of_experience_resume_builder_inGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_years_of_experience_resume_builder_inGrp1 = function() {
    return this.pow_years_of_experience_resume_builder_inValue_ === 1;
  };


  /**
   * Checks if the user is in pow_years_of_experience_resume_builder_inGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPow_years_of_experience_resume_builder_inGrp2 = function() {
    return this.pow_years_of_experience_resume_builder_inValue_ === 2;
  };



  // POWFROMMILITARYPARAMETERTOGGLE


  /**
   * Bucket value for powfrommilitaryparametertoggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.powfrommilitaryparametertoggleValue_;




  /**
   * Checks if the user is in powfrommilitaryparametertoggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleInactive = function() {
    return this.powfrommilitaryparametertoggleValue_ === -1;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleControl = function() {
    return this.powfrommilitaryparametertoggleValue_ === 0;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_seg_nux.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_seg_nux = function() {
    return this.powfrommilitaryparametertoggleValue_ === 1;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_rdc.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_rdc = function() {
    return this.powfrommilitaryparametertoggleValue_ === 2;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_serp.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_serp = function() {
    return this.powfrommilitaryparametertoggleValue_ === 3;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_cg.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_cg = function() {
    return this.powfrommilitaryparametertoggleValue_ === 4;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_ed.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_ed = function() {
    return this.powfrommilitaryparametertoggleValue_ === 5;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_pr.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_pr = function() {
    return this.powfrommilitaryparametertoggleValue_ === 6;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_sm.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_sm = function() {
    return this.powfrommilitaryparametertoggleValue_ === 7;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_dc.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_dc = function() {
    return this.powfrommilitaryparametertoggleValue_ === 8;
  };


  /**
   * Checks if the user is in powfrommilitaryparametertoggleMilitary_context.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowfrommilitaryparametertoggleMilitary_context = function() {
    return this.powfrommilitaryparametertoggleValue_ === 9;
  };



  // POWIPLPHONEINPUTTST


  /**
   * Bucket value for powiplphoneinputtst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.powiplphoneinputtstValue_;




  /**
   * Checks if the user is in powiplphoneinputtstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowiplphoneinputtstInactive = function() {
    return this.powiplphoneinputtstValue_ === -1;
  };


  /**
   * Checks if the user is in powiplphoneinputtstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowiplphoneinputtstControl = function() {
    return this.powiplphoneinputtstValue_ === 0;
  };


  /**
   * Checks if the user is in powiplphoneinputtstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowiplphoneinputtstActive = function() {
    return this.powiplphoneinputtstValue_ === 1;
  };



  // POWREVIEWCOMPANIESLINKTOGGLE


  /**
   * Bucket value for powreviewcompanieslinktoggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.powreviewcompanieslinktoggleValue_;




  /**
   * Checks if the user is in powreviewcompanieslinktoggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowreviewcompanieslinktoggleInactive = function() {
    return this.powreviewcompanieslinktoggleValue_ === -1;
  };


  /**
   * Checks if the user is in powreviewcompanieslinktoggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowreviewcompanieslinktoggleControl = function() {
    return this.powreviewcompanieslinktoggleValue_ === 0;
  };


  /**
   * Checks if the user is in powreviewcompanieslinktoggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPowreviewcompanieslinktoggleActive = function() {
    return this.powreviewcompanieslinktoggleValue_ === 1;
  };



  // PREF_LOCATION_RESUME_BUILDER_IN


  /**
   * Bucket value for pref_location_resume_builder_in.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.pref_location_resume_builder_inValue_;




  /**
   * Checks if the user is in pref_location_resume_builder_inInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPref_location_resume_builder_inInactive = function() {
    return this.pref_location_resume_builder_inValue_ === -1;
  };


  /**
   * Checks if the user is in pref_location_resume_builder_inControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPref_location_resume_builder_inControl = function() {
    return this.pref_location_resume_builder_inValue_ === 0;
  };


  /**
   * Checks if the user is in pref_location_resume_builder_inTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isPref_location_resume_builder_inTest = function() {
    return this.pref_location_resume_builder_inValue_ === 1;
  };



  // PROF_AUTO_RESUME_SECTIONS_SCHEMA_TST


  /**
   * Bucket value for prof_auto_resume_sections_schema_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_auto_resume_sections_schema_tstValue_;




  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstInactive = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstControl = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_auto_resume_sections_schema_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_auto_resume_sections_schema_tstActive = function() {
    return this.prof_auto_resume_sections_schema_tstValue_ === 1;
  };



  // PROF_BACK_BUTTON_LABEL_TOGGLE


  /**
   * Bucket value for prof_back_button_label_toggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_back_button_label_toggleValue_;




  /**
   * Checks if the user is in prof_back_button_label_toggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_back_button_label_toggleInactive = function() {
    return this.prof_back_button_label_toggleValue_ === -1;
  };


  /**
   * Checks if the user is in prof_back_button_label_toggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_back_button_label_toggleControl = function() {
    return this.prof_back_button_label_toggleValue_ === 0;
  };


  /**
   * Checks if the user is in prof_back_button_label_toggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_back_button_label_toggleActive = function() {
    return this.prof_back_button_label_toggleValue_ === 1;
  };



  // PROF_DATA_MERGE_NO_RESUME_TST


  /**
   * Bucket value for prof_data_merge_no_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_data_merge_no_resume_tstValue_;




  /**
   * Checks if the user is in prof_data_merge_no_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_no_resume_tstInactive = function() {
    return this.prof_data_merge_no_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_data_merge_no_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_no_resume_tstControl = function() {
    return this.prof_data_merge_no_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_data_merge_no_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_no_resume_tstTest = function() {
    return this.prof_data_merge_no_resume_tstValue_ === 1;
  };



  // PROF_DATA_MERGE_PARSED_RESUME_TST


  /**
   * Bucket value for prof_data_merge_parsed_resume_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_data_merge_parsed_resume_tstValue_;




  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstInactive = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstControl = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_data_merge_parsed_resume_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_data_merge_parsed_resume_tstTest = function() {
    return this.prof_data_merge_parsed_resume_tstValue_ === 1;
  };



  // PROF_FE_MERGE_SECOND_PHASE


  /**
   * Bucket value for prof_fe_merge_second_phase.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_fe_merge_second_phaseValue_;




  /**
   * Checks if the user is in prof_fe_merge_second_phaseInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseInactive = function() {
    return this.prof_fe_merge_second_phaseValue_ === -1;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseControl = function() {
    return this.prof_fe_merge_second_phaseValue_ === 0;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp1 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 1;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp2 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 2;
  };


  /**
   * Checks if the user is in prof_fe_merge_second_phaseGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_fe_merge_second_phaseGrp3 = function() {
    return this.prof_fe_merge_second_phaseValue_ === 3;
  };



  // PROF_JP_NO_THUMBNAIL


  /**
   * Bucket value for prof_jp_no_thumbnail.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_jp_no_thumbnailValue_;




  /**
   * Checks if the user is in prof_jp_no_thumbnailInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailInactive = function() {
    return this.prof_jp_no_thumbnailValue_ === -1;
  };


  /**
   * Checks if the user is in prof_jp_no_thumbnailControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailControl = function() {
    return this.prof_jp_no_thumbnailValue_ === 0;
  };


  /**
   * Checks if the user is in prof_jp_no_thumbnailTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_jp_no_thumbnailTest = function() {
    return this.prof_jp_no_thumbnailValue_ === 1;
  };



  // PROF_MVP_DATA_MERGE_CROWTAXO_TOG


  /**
   * Bucket value for prof_mvp_data_merge_crowtaxo_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_mvp_data_merge_crowtaxo_togValue_;


  /**
   * Payload value for prof_mvp_data_merge_crowtaxo_tog.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_mvp_data_merge_crowtaxo_togPayloadValue_;


  /**
   * Get the payload value for prof_mvp_data_merge_crowtaxo_tog.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getProf_mvp_data_merge_crowtaxo_togPayloadValue = function() {
    return this.prof_mvp_data_merge_crowtaxo_togPayloadValue_;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togInactive = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === -1;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togControl = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 0;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp1 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 1;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp2 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 2;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp3 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 3;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp4.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp4 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 4;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp5.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp5 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 5;
  };


  /**
   * Checks if the user is in prof_mvp_data_merge_crowtaxo_togGrp6.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_mvp_data_merge_crowtaxo_togGrp6 = function() {
    return this.prof_mvp_data_merge_crowtaxo_togValue_ === 6;
  };



  // PROF_PDF_CONFIRMATION


  /**
   * Bucket value for prof_pdf_confirmation.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_pdf_confirmationValue_;




  /**
   * Checks if the user is in prof_pdf_confirmationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationInactive = function() {
    return this.prof_pdf_confirmationValue_ === -1;
  };


  /**
   * Checks if the user is in prof_pdf_confirmationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationControl = function() {
    return this.prof_pdf_confirmationValue_ === 0;
  };


  /**
   * Checks if the user is in prof_pdf_confirmationActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_pdf_confirmationActive = function() {
    return this.prof_pdf_confirmationValue_ === 1;
  };



  // PROF_REMOVE_CONVERT_TO_INDEED_RESUME_OPTION


  /**
   * Bucket value for prof_remove_convert_to_indeed_resume_option.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_remove_convert_to_indeed_resume_optionValue_;




  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionInactive = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === -1;
  };


  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionControl = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === 0;
  };


  /**
   * Checks if the user is in prof_remove_convert_to_indeed_resume_optionTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_remove_convert_to_indeed_resume_optionTest = function() {
    return this.prof_remove_convert_to_indeed_resume_optionValue_ === 1;
  };



  // PROF_SG_WORK_AUTH_FOR_PARSED_REZ_TST


  /**
   * Bucket value for prof_sg_work_auth_for_parsed_rez_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_sg_work_auth_for_parsed_rez_tstValue_;




  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstInactive = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstControl = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_sg_work_auth_for_parsed_rez_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_sg_work_auth_for_parsed_rez_tstTest = function() {
    return this.prof_sg_work_auth_for_parsed_rez_tstValue_ === 1;
  };



  // PROF_SKILLSET_TOGGLE


  /**
   * Bucket value for prof_skillset_toggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_skillset_toggleValue_;




  /**
   * Checks if the user is in prof_skillset_toggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_skillset_toggleInactive = function() {
    return this.prof_skillset_toggleValue_ === -1;
  };


  /**
   * Checks if the user is in prof_skillset_toggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_skillset_toggleControl = function() {
    return this.prof_skillset_toggleValue_ === 0;
  };


  /**
   * Checks if the user is in prof_skillset_toggleTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_skillset_toggleTest = function() {
    return this.prof_skillset_toggleValue_ === 1;
  };



  // PROF_TABBED_EXP


  /**
   * Bucket value for prof_tabbed_exp.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_expValue_;




  /**
   * Checks if the user is in prof_tabbed_expInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expInactive = function() {
    return this.prof_tabbed_expValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_expControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expControl = function() {
    return this.prof_tabbed_expValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_expTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expTest = function() {
    return this.prof_tabbed_expValue_ === 1;
  };


  /**
   * Checks if the user is in prof_tabbed_expGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expGrp2 = function() {
    return this.prof_tabbed_expValue_ === 2;
  };


  /**
   * Checks if the user is in prof_tabbed_expGrp3.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_expGrp3 = function() {
    return this.prof_tabbed_expValue_ === 3;
  };



  // PROF_TABBED_EXP_RESUME_DATA_IMPORT


  /**
   * Bucket value for prof_tabbed_exp_resume_data_import.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_exp_resume_data_importValue_;




  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importInactive = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importControl = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_data_importTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_data_importTest = function() {
    return this.prof_tabbed_exp_resume_data_importValue_ === 1;
  };



  // PROF_TABBED_EXP_RESUME_IMPORT_PHASE


  /**
   * Bucket value for prof_tabbed_exp_resume_import_phase.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_exp_resume_import_phaseValue_;




  /**
   * Checks if the user is in prof_tabbed_exp_resume_import_phaseInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_import_phaseInactive = function() {
    return this.prof_tabbed_exp_resume_import_phaseValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_import_phaseControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_import_phaseControl = function() {
    return this.prof_tabbed_exp_resume_import_phaseValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_resume_import_phaseMvp.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_resume_import_phaseMvp = function() {
    return this.prof_tabbed_exp_resume_import_phaseValue_ === 1;
  };



  // PROF_TABBED_EXP_SMILEY_SURVEY


  /**
   * Bucket value for prof_tabbed_exp_smiley_survey.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_tabbed_exp_smiley_surveyValue_;




  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyInactive = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === -1;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyControl = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === 0;
  };


  /**
   * Checks if the user is in prof_tabbed_exp_smiley_surveyTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_tabbed_exp_smiley_surveyTest = function() {
    return this.prof_tabbed_exp_smiley_surveyValue_ === 1;
  };



  // PROF_UPLOAD_FILE_REDACTION_TST


  /**
   * Bucket value for prof_upload_file_redaction_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.prof_upload_file_redaction_tstValue_;




  /**
   * Checks if the user is in prof_upload_file_redaction_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstInactive = function() {
    return this.prof_upload_file_redaction_tstValue_ === -1;
  };


  /**
   * Checks if the user is in prof_upload_file_redaction_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstControl = function() {
    return this.prof_upload_file_redaction_tstValue_ === 0;
  };


  /**
   * Checks if the user is in prof_upload_file_redaction_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProf_upload_file_redaction_tstActive = function() {
    return this.prof_upload_file_redaction_tstValue_ === 1;
  };



  // PROFAUTO_CI_RESUME_BUILDER_TST


  /**
   * Bucket value for profauto_ci_resume_builder_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_ci_resume_builder_tstValue_;


  /**
   * Payload value for profauto_ci_resume_builder_tst.
   * @type {Object.<string, Object>}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_ci_resume_builder_tstPayloadValue_;


  /**
   * Get the payload value for profauto_ci_resume_builder_tst.
   * @return {Object.<string, Object>}
   */
  ProfileProctorGroups_.prototype.getProfauto_ci_resume_builder_tstPayloadValue = function() {
    return this.profauto_ci_resume_builder_tstPayloadValue_;
  };


  /**
   * Checks if the user is in profauto_ci_resume_builder_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_ci_resume_builder_tstInactive = function() {
    return this.profauto_ci_resume_builder_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profauto_ci_resume_builder_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_ci_resume_builder_tstControl = function() {
    return this.profauto_ci_resume_builder_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profauto_ci_resume_builder_tstGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_ci_resume_builder_tstGrp1 = function() {
    return this.profauto_ci_resume_builder_tstValue_ === 1;
  };


  /**
   * Checks if the user is in profauto_ci_resume_builder_tstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_ci_resume_builder_tstGrp2 = function() {
    return this.profauto_ci_resume_builder_tstValue_ === 2;
  };



  // PROFAUTO_DOC_TO_PDF_CONVERSION_TST


  /**
   * Bucket value for profauto_doc_to_pdf_conversion_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_doc_to_pdf_conversion_tstValue_;




  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstInactive = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstControl = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profauto_doc_to_pdf_conversion_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_doc_to_pdf_conversion_tstActive = function() {
    return this.profauto_doc_to_pdf_conversion_tstValue_ === 1;
  };



  // PROFAUTO_MINIMUM_PAY_RESUME_BUILDER_TST


  /**
   * Bucket value for profauto_minimum_pay_resume_builder_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profauto_minimum_pay_resume_builder_tstValue_;




  /**
   * Checks if the user is in profauto_minimum_pay_resume_builder_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_minimum_pay_resume_builder_tstInactive = function() {
    return this.profauto_minimum_pay_resume_builder_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profauto_minimum_pay_resume_builder_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_minimum_pay_resume_builder_tstControl = function() {
    return this.profauto_minimum_pay_resume_builder_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profauto_minimum_pay_resume_builder_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfauto_minimum_pay_resume_builder_tstActive = function() {
    return this.profauto_minimum_pay_resume_builder_tstValue_ === 1;
  };



  // PROFILE_ADD_SEGMENTATION_PREFERENCE_TOG


  /**
   * Bucket value for profile_add_segmentation_preference_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_add_segmentation_preference_togValue_;




  /**
   * Checks if the user is in profile_add_segmentation_preference_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_add_segmentation_preference_togInactive = function() {
    return this.profile_add_segmentation_preference_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_add_segmentation_preference_togGrp0.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_add_segmentation_preference_togGrp0 = function() {
    return this.profile_add_segmentation_preference_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_add_segmentation_preference_togGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_add_segmentation_preference_togGrp1 = function() {
    return this.profile_add_segmentation_preference_togValue_ === 1;
  };



  // PROFILE_AI_SUMMARY_TST


  /**
   * Bucket value for profile_ai_summary_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_ai_summary_tstValue_;




  /**
   * Checks if the user is in profile_ai_summary_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstInactive = function() {
    return this.profile_ai_summary_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstControl = function() {
    return this.profile_ai_summary_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstPenguin.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstPenguin = function() {
    return this.profile_ai_summary_tstValue_ === 1;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstGpt4omini.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstGpt4omini = function() {
    return this.profile_ai_summary_tstValue_ === 2;
  };


  /**
   * Checks if the user is in profile_ai_summary_tstGpt4o.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_summary_tstGpt4o = function() {
    return this.profile_ai_summary_tstValue_ === 3;
  };



  // PROFILE_AI_WORK_DESCRIPTION_TST


  /**
   * Bucket value for profile_ai_work_description_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_ai_work_description_tstValue_;




  /**
   * Checks if the user is in profile_ai_work_description_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstInactive = function() {
    return this.profile_ai_work_description_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_ai_work_description_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstControl = function() {
    return this.profile_ai_work_description_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_ai_work_description_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_ai_work_description_tstTest = function() {
    return this.profile_ai_work_description_tstValue_ === 1;
  };



  // PROFILE_EXTRACTED_QUALIFICATIONS_TST


  /**
   * Bucket value for profile_extracted_qualifications_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_extracted_qualifications_tstValue_;




  /**
   * Checks if the user is in profile_extracted_qualifications_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstInactive = function() {
    return this.profile_extracted_qualifications_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_extracted_qualifications_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstControl = function() {
    return this.profile_extracted_qualifications_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_extracted_qualifications_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_extracted_qualifications_tstActive = function() {
    return this.profile_extracted_qualifications_tstValue_ === 1;
  };



  // PROFILE_ONE_DATADOG_RUM_TOGGLE


  /**
   * Bucket value for profile_one_datadog_rum_toggle.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_datadog_rum_toggleValue_;




  /**
   * Checks if the user is in profile_one_datadog_rum_toggleInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleInactive = function() {
    return this.profile_one_datadog_rum_toggleValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_datadog_rum_toggleControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleControl = function() {
    return this.profile_one_datadog_rum_toggleValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_datadog_rum_toggleActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_datadog_rum_toggleActive = function() {
    return this.profile_one_datadog_rum_toggleValue_ === 1;
  };



  // PROFILE_ONE_FULLSTORY_TST


  /**
   * Bucket value for profile_one_fullstory_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_fullstory_tstValue_;




  /**
   * Checks if the user is in profile_one_fullstory_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstInactive = function() {
    return this.profile_one_fullstory_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_fullstory_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstControl = function() {
    return this.profile_one_fullstory_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_fullstory_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_fullstory_tstActive = function() {
    return this.profile_one_fullstory_tstValue_ === 1;
  };



  // PROFILE_ONE_REDESIGN_PREFERENCES_TST


  /**
   * Bucket value for profile_one_redesign_preferences_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_one_redesign_preferences_tstValue_;




  /**
   * Checks if the user is in profile_one_redesign_preferences_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstInactive = function() {
    return this.profile_one_redesign_preferences_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_one_redesign_preferences_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstControl = function() {
    return this.profile_one_redesign_preferences_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_one_redesign_preferences_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_one_redesign_preferences_tstActive = function() {
    return this.profile_one_redesign_preferences_tstValue_ === 1;
  };



  // PROFILE_PHONE_SIMPLIFICATION


  /**
   * Bucket value for profile_phone_simplification.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_phone_simplificationValue_;




  /**
   * Checks if the user is in profile_phone_simplificationInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationInactive = function() {
    return this.profile_phone_simplificationValue_ === -1;
  };


  /**
   * Checks if the user is in profile_phone_simplificationControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationControl = function() {
    return this.profile_phone_simplificationValue_ === 0;
  };


  /**
   * Checks if the user is in profile_phone_simplificationTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_phone_simplificationTest = function() {
    return this.profile_phone_simplificationValue_ === 1;
  };



  // PROFILE_PHOTOS_TOG


  /**
   * Bucket value for profile_photos_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_photos_togValue_;




  /**
   * Checks if the user is in profile_photos_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togInactive = function() {
    return this.profile_photos_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_photos_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togControl = function() {
    return this.profile_photos_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_photos_togActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_photos_togActive = function() {
    return this.profile_photos_togValue_ === 1;
  };



  // PROFILE_TEXT_EXPERIENCE_INPUT_TST


  /**
   * Bucket value for profile_text_experience_input_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_text_experience_input_tstValue_;




  /**
   * Checks if the user is in profile_text_experience_input_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstInactive = function() {
    return this.profile_text_experience_input_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_text_experience_input_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstControl = function() {
    return this.profile_text_experience_input_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_text_experience_input_tstActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_text_experience_input_tstActive = function() {
    return this.profile_text_experience_input_tstValue_ === 1;
  };



  // PROFILE_TITLE_MATCH_AUTOCOMPLETE_DATASET_TST


  /**
   * Bucket value for profile_title_match_autocomplete_dataset_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_title_match_autocomplete_dataset_tstValue_;


  /**
   * Payload value for profile_title_match_autocomplete_dataset_tst.
   * @type {Object}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_title_match_autocomplete_dataset_tstPayloadValue_;


  /**
   * Get the payload value for profile_title_match_autocomplete_dataset_tst.
   * @return {Object}
   */
  ProfileProctorGroups_.prototype.getProfile_title_match_autocomplete_dataset_tstPayloadValue = function() {
    return this.profile_title_match_autocomplete_dataset_tstPayloadValue_;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstInactive = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === -1;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstControl = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 0;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoComplete.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoComplete = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 1;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonOnly.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonOnly = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 2;
  };


  /**
   * Checks if the user is in profile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonAltLabels.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_title_match_autocomplete_dataset_tstEnableJobTypeAutoCompleteCanonAltLabels = function() {
    return this.profile_title_match_autocomplete_dataset_tstValue_ === 3;
  };



  // PROFILE_UPDATE_APP_BANNER_TOG


  /**
   * Bucket value for profile_update_app_banner_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_update_app_banner_togValue_;




  /**
   * Checks if the user is in profile_update_app_banner_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togInactive = function() {
    return this.profile_update_app_banner_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_update_app_banner_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togControl = function() {
    return this.profile_update_app_banner_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_update_app_banner_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_update_app_banner_togTest = function() {
    return this.profile_update_app_banner_togValue_ === 1;
  };



  // PROFILE_YOE_REMOVAL_TOG


  /**
   * Bucket value for profile_yoe_removal_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.profile_yoe_removal_togValue_;




  /**
   * Checks if the user is in profile_yoe_removal_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togInactive = function() {
    return this.profile_yoe_removal_togValue_ === -1;
  };


  /**
   * Checks if the user is in profile_yoe_removal_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togControl = function() {
    return this.profile_yoe_removal_togValue_ === 0;
  };


  /**
   * Checks if the user is in profile_yoe_removal_togTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isProfile_yoe_removal_togTest = function() {
    return this.profile_yoe_removal_togValue_ === 1;
  };



  // RAVEN_US_EPAS_PROFILE_ENRICHMENT_EML_TST_1_MVTST


  /**
   * Bucket value for raven_us_epas_profile_enrichment_eml_tst_1_mvtst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_;




  /**
   * Checks if the user is in raven_us_epas_profile_enrichment_eml_tst_1_mvtstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRaven_us_epas_profile_enrichment_eml_tst_1_mvtstInactive = function() {
    return this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ === -1;
  };


  /**
   * Checks if the user is in raven_us_epas_profile_enrichment_eml_tst_1_mvtstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRaven_us_epas_profile_enrichment_eml_tst_1_mvtstControl = function() {
    return this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ === 0;
  };


  /**
   * Checks if the user is in raven_us_epas_profile_enrichment_eml_tst_1_mvtstGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRaven_us_epas_profile_enrichment_eml_tst_1_mvtstGrp1 = function() {
    return this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ === 1;
  };


  /**
   * Checks if the user is in raven_us_epas_profile_enrichment_eml_tst_1_mvtstGrp2.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRaven_us_epas_profile_enrichment_eml_tst_1_mvtstGrp2 = function() {
    return this.raven_us_epas_profile_enrichment_eml_tst_1_mvtstValue_ === 2;
  };



  // RDP_PDF_RESUME_FACELIFT


  /**
   * Bucket value for rdp_pdf_resume_facelift.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.rdp_pdf_resume_faceliftValue_;




  /**
   * Checks if the user is in rdp_pdf_resume_faceliftInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftInactive = function() {
    return this.rdp_pdf_resume_faceliftValue_ === -1;
  };


  /**
   * Checks if the user is in rdp_pdf_resume_faceliftControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftControl = function() {
    return this.rdp_pdf_resume_faceliftValue_ === 0;
  };


  /**
   * Checks if the user is in rdp_pdf_resume_faceliftTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRdp_pdf_resume_faceliftTest = function() {
    return this.rdp_pdf_resume_faceliftValue_ === 1;
  };



  // RE_UPLOAD_TO_REPLACE


  /**
   * Bucket value for re_upload_to_replace.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.re_upload_to_replaceValue_;




  /**
   * Checks if the user is in re_upload_to_replaceInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceInactive = function() {
    return this.re_upload_to_replaceValue_ === -1;
  };


  /**
   * Checks if the user is in re_upload_to_replaceControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceControl = function() {
    return this.re_upload_to_replaceValue_ === 0;
  };


  /**
   * Checks if the user is in re_upload_to_replaceTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isRe_upload_to_replaceTest = function() {
    return this.re_upload_to_replaceValue_ === 1;
  };



  // SEGMENT_SELECTION_INDIA_TST


  /**
   * Bucket value for segment_selection_india_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.segment_selection_india_tstValue_;




  /**
   * Checks if the user is in segment_selection_india_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSegment_selection_india_tstInactive = function() {
    return this.segment_selection_india_tstValue_ === -1;
  };


  /**
   * Checks if the user is in segment_selection_india_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSegment_selection_india_tstControl = function() {
    return this.segment_selection_india_tstValue_ === 0;
  };


  /**
   * Checks if the user is in segment_selection_india_tstGrp1.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSegment_selection_india_tstGrp1 = function() {
    return this.segment_selection_india_tstValue_ === 1;
  };



  // SI_PROFILE_EDUCATION_DESCRIPTION_INITIALLY_HIDDEN_TST


  /**
   * Bucket value for si_profile_education_description_initially_hidden_tst.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.si_profile_education_description_initially_hidden_tstValue_;




  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstInactive = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === -1;
  };


  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstControl = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === 0;
  };


  /**
   * Checks if the user is in si_profile_education_description_initially_hidden_tstTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSi_profile_education_description_initially_hidden_tstTest = function() {
    return this.si_profile_education_description_initially_hidden_tstValue_ === 1;
  };



  // SUGGESTIONS_UI_UPDATE_FLOWS


  /**
   * Bucket value for suggestions_ui_update_flows.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.suggestions_ui_update_flowsValue_;




  /**
   * Checks if the user is in suggestions_ui_update_flowsInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSuggestions_ui_update_flowsInactive = function() {
    return this.suggestions_ui_update_flowsValue_ === -1;
  };


  /**
   * Checks if the user is in suggestions_ui_update_flowsControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSuggestions_ui_update_flowsControl = function() {
    return this.suggestions_ui_update_flowsValue_ === 0;
  };


  /**
   * Checks if the user is in suggestions_ui_update_flowsTest.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isSuggestions_ui_update_flowsTest = function() {
    return this.suggestions_ui_update_flowsValue_ === 1;
  };



  // TITLE_MATCH_AUTOCOMPLETE_LOGGING_TOG


  /**
   * Bucket value for title_match_autocomplete_logging_tog.
   * @type {number}
   * @private
   */
  ProfileProctorGroups_.prototype.title_match_autocomplete_logging_togValue_;




  /**
   * Checks if the user is in title_match_autocomplete_logging_togInactive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isTitle_match_autocomplete_logging_togInactive = function() {
    return this.title_match_autocomplete_logging_togValue_ === -1;
  };


  /**
   * Checks if the user is in title_match_autocomplete_logging_togControl.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isTitle_match_autocomplete_logging_togControl = function() {
    return this.title_match_autocomplete_logging_togValue_ === 0;
  };


  /**
   * Checks if the user is in title_match_autocomplete_logging_togActive.
   * @return {boolean}
   */
  ProfileProctorGroups_.prototype.isTitle_match_autocomplete_logging_togActive = function() {
    return this.title_match_autocomplete_logging_togValue_ === 1;
  };



  /**
  * Static reference to instance of groups class.
  *
  * @type {ProfileProctorGroups_}
  * @private
  */
  var groups_ = null;

  return {

    /**
    * Create an instance of ProfileProctorGroups_.
    * Assign it to a static reference and return it.
    *
    * @param {Array.<Object>} values a list of integers that matches proctor test groups for the request.
    * @return {ProfileProctorGroups_}
    */
    init: function(values) {
      groups_ = new ProfileProctorGroups_(values);
      return groups_;
    },


    /**
    * Get the static reference to our groups instance.
    * If it has not been initialized, return a default instance.
    *
    * @return {ProfileProctorGroups_}
    */
    getGroups: function() {
      if (groups_ == null) {
        groups_ = new ProfileProctorGroups_();
      }
      return groups_;
    }

  };
}));
